// import React, { useState, useEffect, useMemo, useCallback } from "react";
// import AppBar from "@mui/material/AppBar";
// import Box from "@mui/material/Box";
// import CssBaseline from "@mui/material/CssBaseline";
// import Divider from "@mui/material/Divider";
// import Drawer from "@mui/material/Drawer";
// import IconButton from "@mui/material/IconButton";
// import List from "@mui/material/List";
// import ListItem from "@mui/material/ListItem";
// import ListItemButton from "@mui/material/ListItemButton";
// import ListItemIcon from "@mui/material/ListItemIcon";
// import ListItemText from "@mui/material/ListItemText";
// import Toolbar from "@mui/material/Toolbar";
// import Typography from "@mui/material/Typography";
// import Menu from "@mui/material/Menu";
// import MenuItem from "@mui/material/MenuItem";
// import MenuIcon from "@mui/icons-material/Menu";
// import CalendarViewMonthIcon from "@mui/icons-material/CalendarViewMonth";
// import PersonIcon from "@mui/icons-material/Person";
// import PersonAddIcon from "@mui/icons-material/PersonAdd";
// import TransferWithinAStationIcon from "@mui/icons-material/TransferWithinAStation";
// import EditCalendarIcon from "@mui/icons-material/EditCalendar";
// import PasswordIcon from "@mui/icons-material/Password";
// import LogoutIcon from "@mui/icons-material/Logout";
// import AccountCircleIcon from "@mui/icons-material/AccountCircle";
// import SearchIcon from "@mui/icons-material/Search";
// import ListIcon from "@mui/icons-material/List"; // Added for Appointment List
// import FullCalendarApp from "./FullCalendarApp";
// import Clients from "../screens/clients.screen";
// import UserForm from "../screens/new_client.screen";
// import AppointmentForm from "../screens/new_appointment.screen";
// import Staff from "../screens/staff.screen";
// import ResetPasswordForm from "../screens/reset_password.screen";
// import MakeExcelFile from "../screens/make.excel.file.screen";
// import Reports from "../screens/reports.screen";
// import AssignedClientStats from "../screens/AssignedClientStats";
// import EditDeleteAppointment from "../screens/EditDeleteAppointment";
// import ClientStats from "../screens/ClientStats";
// import EditDeleteUsers from "../screens/EditDeleteUsers";
// import SearchUsers from "../screens/SearchUsers";
// import SendEmailSMS from "../screens/SendEmailSMSExel";
// import AppointmentListView from "../screens/AppointmentListView" // Import the new component
// import { useTranslation } from "react-i18next";
// import Cookies from "js-cookie";
// import { useStateContext } from "../context/ContextProvider";
// import { LegendToggle, Note } from "@mui/icons-material";
// import AppointmentList from "../screens/AppointmentList";
// import Notes from "../screens/Notes";
// import axiosClient from "../axiosClient";
// import GDPRPOLICY from "../screens/GdprPolicyScreen";
// //////////////////////////////////////////
// import GDPRPolicyLink from "./GDPRPolicyLink";
// //////////////////////////////////////////
// import Modal from "@mui/material/Modal";
// import ExpandLess from '@mui/icons-material/ExpandLess';
// import ExpandMore from '@mui/icons-material/ExpandMore';
// import Collapse from "@mui/material/Collapse";
// import Profile from "../screens/UserProfileScreen";
// import { useThemeContext } from "../context/ThemeContext";
// import { Tooltip } from "@mui/material";
// import Brightness4Icon from "@mui/icons-material/Brightness4";
// import Brightness7Icon from "@mui/icons-material/Brightness7";
// import { useTheme } from '@mui/material/styles';

// // DrawerApp component: Main navigation and layout for the Patient Hub application
// function DrawerApp() {
//   // Access Material-UI theme
//   const theme = useTheme();
//   // Theme context for toggling light/dark mode
//   const { mode, toggleTheme } = useThemeContext();
//   // Drawer width configuration
//   const drawerWidth = 260;
//   // Context for user authentication and token management
//   const { user, _setUser, setToken, token } = useStateContext();
//   // State for mobile drawer visibility
//   const [mobileOpen, setMobileOpen] = useState(false);
//   // State to track drawer closing transition
//   const [isClosing, setIsClosing] = useState(false);
//   // State for selected appointment ID
//   const [selectedAppointmentId, setSelectedAppointmentId] = useState(null);
//   // State for GDPR modal visibility
//   const [showGDPRModal, setShowGDPRModal] = useState(false);
//   // State for GDPR agreement submission
//   const [isSubmittingAgreement, setIsSubmittingAgreement] = useState(false);
//   // State for monitoring submenu visibility
//   const [submenuOpen, setSubmenuOpen] = useState(false);
//   // State for user management menu visibility
//   const [userMenuOpen, setUserMenuOpen] = useState(false);
//   // State for appointments menu visibility
//   const [appointmentMenuOpen, setAppointmentMenuOpen] = useState(false);
//   // State for user menu anchor element
//   const [anchorEl, setAnchorEl] = useState(null);

//   // Context for view management
//   const { view, setView } = useStateContext();
//   const { t, i18n } = useTranslation();

//   // Effect to open relevant menus based on current view
//   useEffect(() => {
//     // if (['clients', 'search_users', 'new_user', 'edit_delete_user'].includes(view)) {
//       if (['clients', 'search_users', 'new_user', 'edit_delete_user', 'staff'].includes(view)) {
//       setUserMenuOpen(true);
//     }
//     if (['appointments', 'my_appointment', 'create_appointment', 'edit_delete_appointment', 'appointment_list'].includes(view)) {
//       setAppointmentMenuOpen(true);
//     }
//     if (['make_excel_file', 'send_email_sms', 'reports', 'assigned_client_stats', 'client_stats'].includes(view)) {
//       setSubmenuOpen(true);
//     }
//   }, [view]);

//   // Placeholder for user data refresh on page load
//   useEffect(() => {
//     // TODO: Implement API call to refresh user data using token from headers
//   }, []);

//   // Effect to show GDPR modal for clients who haven't accepted it
//   useEffect(() => {
//     if (user?.user_role === 'CLIENT' && !user.gdpr_accepted) {
//       setShowGDPRModal(true);
//     }
//   }, [user]);

//   // Function to change application language
//   const changeLanguage = (lng) => {
//     i18n.changeLanguage(lng);
//   };

//   // Handle drawer close for mobile view
//   const handleDrawerClose = () => {
//     setIsClosing(true);
//     setMobileOpen(false);
//   };

//   // Handle drawer transition end
//   const handleDrawerTransitionEnd = () => {
//     setIsClosing(false);
//   };

//   // Toggle drawer visibility for mobile view
//   const handleDrawerToggle = () => {
//     if (!isClosing) {
//       setMobileOpen(!mobileOpen);
//     }
//   };

//   // Handle saving an appointment
//   const handleSaveAppointment = () => {
//     setSelectedAppointmentId(null);
//     setView("appointments");
//   };

//   // Handle deleting an appointment
//   const handleDeleteAppointment = () => {
//     setSelectedAppointmentId(null);
//     setView("appointments");
//   };

//   // Download GDPR report as PDF
//   const downloadGDPRreport = useCallback(async () => {
//     try {
//       const response = await axiosClient.get("api/gdpr-report", {
//         responseType: "blob",
//       });
//       const blob = new Blob([response.data], { type: "application/pdf" });
//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", `report.pdf`);
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       window.URL.revokeObjectURL(url);
//     } catch (error) {
//       console.error("Error downloading the PDF", error);
//     }
//   }, []); // Empty dependency array since axiosClient is stable

//   // Handle GDPR agreement submission
//   const handleGDPRAgreement = async () => {
//     setIsSubmittingAgreement(true);
//     try {
//       const ipRes = await fetch('https://api.ipify.org?format=json');
//       const { ip } = await ipRes.json();
//       await axiosClient.post('/api/gdpr/accept/', {
//         ip_address: ip,
//         agreement_time: new Date().toISOString()
//       }, {
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "*/*",
//           Authorization: `JWT-${token}`,
//         },
//       });
//       _setUser({ ...user, gdpr_accepted: true });
//       setShowGDPRModal(false);
//     } catch (err) {
//       if (err.response && err.response.data) {
//         alert(err.response.data[0] || 'Failed to accept GDPR.');
//       } else {
//         console.error('GDPR agreement failed:', err);
//       }
//     } finally {
//       setIsSubmittingAgreement(false);
//     }
//   };

//   // Open user profile menu
//   const handleUserMenuClick = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   // Close user profile menu
//   const handleUserMenuClose = () => {
//     setAnchorEl(null);
//   };

//   // Navigate to user profile view
//   const handleProfileClick = () => {
//     setView("user_profile");
//     handleUserMenuClose();
//   };

//   // Styles for active menu items
//   const activeItemStyle = {
//     bgcolor: "primary.main",
//     color: `${theme.palette.mode === "light" ? "black" : "white"}`,
//     "& .MuiListItemIcon-root": {
//       color: `${theme.palette.mode === "light" ? "black" : "white"}`,
//     },
//   };

//   // Check if a view is active
//   const isActive = (viewName) => view === viewName;

//   // Memoized primary menu items
//   const primaryMenuItems = useMemo(() => [
//     // {
//     //   name: t("Clients to staff"),
//     //   icon: <TransferWithinAStationIcon />,
//     //   view: "staff",
//     //   handleClick: () => setView("staff"),
//     //   canSee: ["ADMIN", "STAFF"],
//     // },
//     {
//       name: t("Notes"),
//       icon: <Note />,
//       view: "notes",
//       handleClick: () => setView("notes"),
//       canSee: ["ADMIN"],
//     },
//   ], [t, setView]);

//   // Memoized GDPR menu items
//   const gdprMenuItems = useMemo(() => [
//     {
//       name: t("GDPR REPORT"),
//       icon: <Note />,
//       view: null,
//       handleClick: () => downloadGDPRreport(),
//       canSee: ["CLIENT"],
//     },
//     {
//       name: t("GDPR POLICY"),
//       icon: <Note />,
//       view: "gdpr_policy",
//       handleClick: () => setView("gdpr_policy"),
//       canSee: ["ADMIN", "STAFF", "CLIENT"],
//     },
//   ], [t, setView, downloadGDPRreport]);

//   // Drawer content for navigation
//   const drawer = (
//     <div>
//       {/* User profile section */}
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           marginTop: 2,
//           marginBottom: 1,
//         }}
//       >
//         <ListItemButton
//           onClick={handleUserMenuClick}
//           sx={{
//             display: 'flex',
//             alignItems: 'center'
//           }}
//         >
//           <AccountCircleIcon />
//           <Typography variant="body2" align="center" sx={{ ml: 4, fontSize: "14px" }}>
//             {`${user.first_name} ${user.last_name}`}
//           </Typography>
//         </ListItemButton>
//         <Menu
//           anchorEl={anchorEl}
//           open={Boolean(anchorEl)}
//           onClose={handleUserMenuClose}
//           anchorOrigin={{
//             vertical: 'bottom',
//             horizontal: 'center',
//           }}
//           transformOrigin={{
//             vertical: 'top',
//             horizontal: 'center',
//           }}
//         >
//           <MenuItem onClick={handleProfileClick}><Typography variant="body2">{t("Profile")}</Typography></MenuItem>
//         </Menu>
//       </Box>
//       <Divider />

//       {/* Users Management menu for ADMIN and STAFF */}
//       {(user.user_role === "ADMIN" || user.user_role === "STAFF") && (
//         <>
//           <ListItemButton
//             sx={{
//               borderRadius: 2,
//               mx: 0,
//               my: 0.5,
//               "&:hover": {
//                 bgcolor: "action.hover",
//               },
//               // ...(['clients', 'search_users', 'new_user', 'edit_delete_user'].includes(view) && { bgcolor: "action.selected" })
//               ...(['clients', 'search_users', 'new_user', 'edit_delete_user', 'staff'].includes(view) && { bgcolor: "action.selected" })
//             }}
//             onClick={() => setUserMenuOpen(!userMenuOpen)}
//           >
//             <ListItemIcon>
//               <PersonIcon />
//             </ListItemIcon>
//             <ListItemText primary={t("Users Management")} primaryTypographyProps={{ variant: "body2" }} />
//             {userMenuOpen ? <ExpandLess /> : <ExpandMore />}
//           </ListItemButton>
//           <Collapse in={userMenuOpen} timeout={{ enter: 100, exit: 100 }} unmountOnExit>
//             <List component="div" disablePadding>
//               <ListItemButton
//                 sx={{
//                   pl: 4,
//                   ...(isActive("clients") && activeItemStyle)
//                 }}
//                 onClick={() => setView("clients")}
//                 selected={isActive("clients")}
//               >
//                 <ListItemIcon>
//                   <PersonIcon />
//                 </ListItemIcon>
//                 <ListItemText primary={t("Users")} primaryTypographyProps={{ variant: "body2" }} />
//               </ListItemButton>
//               <ListItemButton
//                 sx={{
//                   pl: 4,
//                   ...(isActive("search_users") && activeItemStyle)
//                 }}
//                 onClick={() => setView("search_users")}
//                 selected={isActive("search_users")}
//               >
//                 <ListItemIcon>
//                   <SearchIcon />
//                 </ListItemIcon>
//                 <ListItemText primary={t("Search Users")} primaryTypographyProps={{ variant: "body2" }} />
//               </ListItemButton>
//               <ListItemButton
//                 sx={{
//                   pl: 4,
//                   ...(isActive("new_user") && activeItemStyle)
//                 }}
//                 onClick={() => setView("new_user")}
//                 selected={isActive("new_user")}
//               >
//                 <ListItemIcon>
//                   <PersonAddIcon />
//                 </ListItemIcon>
//                 <ListItemText primary={t("New User")} primaryTypographyProps={{ variant: "body2" }} />
//               </ListItemButton>
//               <ListItemButton
//                 sx={{
//                   pl: 4,
//                   ...(isActive("edit_delete_user") && activeItemStyle)
//                 }}
//                 onClick={() => setView("edit_delete_user")}
//                 selected={isActive("edit_delete_user")}
//               >
//                 <ListItemIcon>
//                   <PersonIcon />
//                 </ListItemIcon>
//                 <ListItemText primary={t("Edit/Delete User")} primaryTypographyProps={{ variant: "body2" }} />
//               </ListItemButton>


// {/* ΝΕΟ: Clients to staff μέσα στο Users Management */}
//     <ListItemButton
//       sx={{
//         pl: 4,
//         ...(isActive("staff") && activeItemStyle)
//       }}
//       onClick={() => setView("staff")}
//       selected={isActive("staff")}
//     >
//       <ListItemIcon>
//         <TransferWithinAStationIcon />
//       </ListItemIcon>
//       <ListItemText
//         primary={t("Clients to staff")}
//         primaryTypographyProps={{ variant: "body2" }}
//       />
//     </ListItemButton>


//             </List>
//           </Collapse>
//         </>
//       )}

//       {/* Appointments menu */}
//       <ListItemButton
//         sx={{
//           borderRadius: 2,
//           mx: 0,
//           my: 0.5,
//           "&:hover": {
//             bgcolor: "action.hover",
//           },
//           ...(['appointments', 'my_appointment', 'create_appointment', 'edit_delete_appointment', 'appointment_list'].includes(view) && { bgcolor: "action.selected" })
//         }}
//         onClick={() => setAppointmentMenuOpen(!appointmentMenuOpen)}
//       >
//         <ListItemIcon>
//           <CalendarViewMonthIcon />
//         </ListItemIcon>
//         <ListItemText primary={t("Appointments")} primaryTypographyProps={{ variant: "body2" }} />
//         {appointmentMenuOpen ? <ExpandLess /> : <ExpandMore />}
//       </ListItemButton>
//       <Collapse in={appointmentMenuOpen} timeout={{ enter: 100, exit: 100 }} unmountOnExit>
//         <List component="div" disablePadding>
//           <ListItemButton
//             sx={{
//               pl: 4,
//               ...(isActive("appointments") && activeItemStyle)
//             }}
//             onClick={() => setView("appointments")}
//             selected={isActive("appointments")}
//           >
//             <ListItemIcon>
//               <CalendarViewMonthIcon />
//             </ListItemIcon>
//             <ListItemText primary={t("View Appointments")} primaryTypographyProps={{ variant: "body2" }} />
//           </ListItemButton>
//           <ListItemButton
//             sx={{
//               pl: 4,
//               ...(isActive("appointment_list") && activeItemStyle)
//             }}
//             onClick={() => setView("appointment_list")}
//             selected={isActive("appointment_list")}
//           >
//             <ListItemIcon>
//               <ListIcon />
//             </ListItemIcon>
//             <ListItemText primary={t("Appointment List")} primaryTypographyProps={{ variant: "body2" }} />
//           </ListItemButton>
//           {user.user_role === "CLIENT" && (
//             <ListItemButton
//               sx={{
//                 pl: 4,
//                 ...(isActive("my_appointment") && activeItemStyle)
//               }}
//               onClick={() => setView("my_appointment")}
//               selected={isActive("my_appointment")}
//             >
//               <ListItemIcon>
//                 <CalendarViewMonthIcon />
//               </ListItemIcon>
//               <ListItemText primary={t("MY Appointments")} primaryTypographyProps={{ variant: "body2" }} />
//             </ListItemButton>
//           )}
//           {(user.user_role === "ADMIN" || user.user_role === "STAFF") && (
//             <>
//               <ListItemButton
//                 sx={{
//                   pl: 4,
//                   ...(isActive("create_appointment") && activeItemStyle)
//                 }}
//                 onClick={() => setView("create_appointment")}
//                 selected={isActive("create_appointment")}
//               >
//                 <ListItemIcon>
//                   <EditCalendarIcon />
//                 </ListItemIcon>
//                 <ListItemText primary={t("Create appointment")} primaryTypographyProps={{ variant: "body2" }} />
//               </ListItemButton>
//               <ListItemButton
//                 sx={{
//                   pl: 4,
//                   ...(isActive("edit_delete_appointment") && activeItemStyle)
//                 }}
//                 onClick={() => setView("edit_delete_appointment")}
//                 selected={isActive("edit_delete_appointment")}
//               >
//                 <ListItemIcon>
//                   <EditCalendarIcon />
//                 </ListItemIcon>
//                 <ListItemText primary={t("Edit/Delete appointment")} primaryTypographyProps={{ variant: "body2" }} />
//               </ListItemButton>
//             </>
//           )}
//         </List>
//       </Collapse>

//       {/* Primary menu items (Clients to staff, Notes) */}
//       <List>
//         {primaryMenuItems.map((object) => {
//           if (object.canSee.includes(user.user_role)) {
//             return (
//               <ListItem key={object.name} disablePadding>
//                 <ListItemButton
//                   onClick={object.handleClick}
//                   sx={{
//                     ...(isActive(object.view) && activeItemStyle),
//                     borderRadius: 1
//                   }}
//                   selected={isActive(object.view)}
//                 >
//                   <ListItemIcon>{object.icon}</ListItemIcon>
//                   <ListItemText primary={object.name} primaryTypographyProps={{ variant: "body2" }} />
//                 </ListItemButton>
//               </ListItem>
//             );
//           } else {
//             return null;
//           }
//         })}

//         {/* Monitoring submenu for ADMIN and STAFF */}
//         {(user.user_role === "ADMIN" || user.user_role === "STAFF") && (
//           <>
//             <ListItemButton
//               sx={{
//                 borderRadius: 2,
//                 mx: 0,
//                 my: 0.5,
//                 "&:hover": {
//                   bgcolor: "action.hover",
//                 },
//                 ...(['make_excel_file', 'send_email_sms', 'reports', 'assigned_client_stats', 'client_stats'].includes(view) && { bgcolor: "action.selected" })
//               }}
//               onClick={() => setSubmenuOpen(!submenuOpen)}
//             >
//               <ListItemIcon>
//                 <LegendToggle />
//               </ListItemIcon>
//               <ListItemText primary={

//                 t("Monitoring")} primaryTypographyProps={{ variant: "body2" }} />
//               {submenuOpen ? <ExpandLess /> : <ExpandMore />}
//             </ListItemButton>
//             <Collapse in={submenuOpen} timeout={{ enter: 100, exit: 100 }} unmountOnExit>
//               <List component="div" disablePadding>
//                 <ListItemButton
//                   sx={{
//                     pl: 4,
//                     ...(isActive("make_excel_file") && activeItemStyle)
//                   }}
//                   onClick={() => setView("make_excel_file")}
//                   selected={isActive("make_excel_file")}
//                 >
//                   <ListItemText inset primary={t("Make excel file")} primaryTypographyProps={{ variant: "body2" }} />
//                 </ListItemButton>
//                 <ListItemButton
//                   sx={{
//                     pl: 4,
//                     ...(isActive("send_email_sms") && activeItemStyle)
//                   }}
//                   onClick={() => setView("send_email_sms")}
//                   selected={isActive("send_email_sms")}
//                 >
//                   <ListItemText
//                     inset
//                     primary={t("Send Email/SMS excel file")}
//                     primaryTypographyProps={{ variant: "body2" }}
//                   />
//                 </ListItemButton>
//                 <ListItemButton
//                   sx={{
//                     pl: 4,
//                     ...(isActive("reports") && activeItemStyle)
//                   }}
//                   onClick={() => setView("reports")}
//                   selected={isActive("reports")}
//                 >
//                   <ListItemText inset primary={t("Reports")} primaryTypographyProps={{ variant: "body2" }} />
//                 </ListItemButton>
//                 <ListItemButton
//                   sx={{
//                     pl: 4,
//                     ...(isActive("assigned_client_stats") && activeItemStyle)
//                   }}
//                   onClick={() => setView("assigned_client_stats")}
//                   selected={isActive("assigned_client_stats")}
//                 >
//                   <ListItemText inset primary={t("Assigned Client Stats")} primaryTypographyProps={{ variant: "body2" }} />
//                 </ListItemButton>
//                 <ListItemButton
//                   sx={{
//                     pl: 4,
//                     ...(isActive("client_stats") && activeItemStyle)
//                   }}
//                   onClick={() => setView("client_stats")}
//                   selected={isActive("client_stats")}
//                 >
//                   <ListItemText inset primary={t("Client Stats")} primaryTypographyProps={{ variant: "body2" }} />
//                 </ListItemButton>
//               </List>
//             </Collapse>
//           </>
//         )}
//       </List>

//       {/* GDPR menu items */}
//       <List>
//         {gdprMenuItems.map((object) => {
//           if (object.canSee.includes(user.user_role)) {
//             return (
//               <ListItem key={object.name} disablePadding>
//                 <ListItemButton
//                   onClick={object.handleClick}
//                   sx={{
//                     ...(object.view && isActive(object.view) && activeItemStyle),
//                     borderRadius: 1
//                   }}
//                   selected={object.view && isActive(object.view)}
//                 >
//                   <ListItemIcon>{object.icon}</ListItemIcon>
//                   <ListItemText primary={object.name} primaryTypographyProps={{ variant: "body2" }} />
//                 </ListItemButton>
//               </ListItem>
//             );
//           } else {
//             return null;
//           }
//         })}
//       </List>
//       <Divider />
//       {/* Reset password and logout options */}
//       <List>
//         {[
//           {
//             name: `${t("Reset password")}`,
//             icon: <PasswordIcon />,
//             view: "reset_password",
//             handleClick: () => setView("reset_password"),
//           },
//           {
//             name: `${t("Logout")}`,
//             icon: <LogoutIcon />,
//             view: null,
//             handleClick: () => {
//               setToken(null);
//               _setUser({});
//               window.location.reload();
//             },
//           },
//         ].map((object) => (
//           <ListItem key={object.name} disablePadding>
//             <ListItemButton
//               onClick={object.handleClick}
//               sx={{
//                 ...(object.view && isActive(object.view) && activeItemStyle),
//                 borderRadius: 1
//               }}
//               selected={object.view && isActive(object.view)}
//             >
//               <ListItemIcon>{object.icon}</ListItemIcon>
//               <ListItemText primary={object.name} primaryTypographyProps={{ variant: "body2" }} />
//             </ListItemButton>
//           </ListItem>
//         ))}
//       </List>
//     </div>
//   );

//   // Main render
//   return (
//     <div className="App">
//       {/* GDPR Modal for clients */}
//       {showGDPRModal && (
//         <Modal
//           open={showGDPRModal}
//           onClose={() => { }}
//           disableEscapeKeyDown
//         >
//           <Box sx={{
//             position: 'absolute',
//             top: '50%',
//             left: '50%',
//             transform: 'translate(-50%, -50%)',
//             width: '90%',
//             maxWidth: 800,
//             maxHeight: '90vh',
//             bgcolor: 'background.paper',
//             boxShadow: 24,
//             p: 4,
//             overflowY: 'auto',
//           }}>
//             <GDPRPOLICY
//               onAgree={handleGDPRAgreement}
//               isModal={true}
//               isSubmitting={isSubmittingAgreement}
//             />
//           </Box>
//         </Modal>
//       )}
//       <Box sx={{ display: "flex" }}>
//         <CssBaseline />
//         {/* Top AppBar */}
//         <AppBar
//           position="fixed"
//           sx={{
//             width: { sm: `calc(100% - ${drawerWidth}px)` },
//             ml: { sm: `${drawerWidth}px` },
//           }}
//         >
//           <Toolbar>
//             <IconButton
//               color="inherit"
//               aria-label="open drawer"
//               edge="start"
//               onClick={handleDrawerToggle}
//               sx={{ mr: 2, display: { sm: "none" } }}
//             >
//               <MenuIcon />
//             </IconButton>
//             <Box
//               sx={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 width: "90%",
//               }}
//             >
//               {/* <Typography
//                 variant="h6"
//                 noWrap
//                 component="div"
//                 sx={{
//                   flexGrow: 1,
//                   mr: 2
//                 }}
//               > */}

//                 {/* {t("Patient Hub - A simple patient management system")} */}
//                  {/* {t("Tempus Management System ")}  */}
//                {/*Added font */  }
//                  {/* <Typography variant="h6" noWrap sx={{ fontFamily: "Dreaming Outloud Script Pro", fontSize: "28px" }}>
//                 Tempus Management System  
//                 </Typography> */}

//                 {/* <Typography
//                 variant="h6"
//                 noWrap
//                 sx={{
//                   fontFamily: "TempusFont, Arial, sans-serif",
//                   fontSize: "32px",
//                   letterSpacing: "1px",
//                 }}
//               >
//                 Tempus Management System
//               </Typography> */}



//                 {/* <Typography
//                 variant="h6"
//                 noWrap
//                 sx={{
//                   fontFamily: "TempusFont, Arial, sans-serif",
//                   fontSize: "32px",
//                   fontWeight: 400,
//                   letterSpacing: "1px",
//                 }}
//               >
//   Tempus Management System
// </Typography>
//    */}           
//                 <Typography
//                 variant="h6"
//                 noWrap
//                 component="div"
//                 sx={{
//                   flexGrow: 1,
//                   mr: 2,
//                   fontFamily: "TempusFont, Arial, sans-serif",
//                   fontSize: "32px",
//                   fontWeight: 400,
//                   letterSpacing: "1px",
//                 }}
//               >
//                 Tempus Management System
//               </Typography>
  





//               {/* </Typography> */}
//               <Box
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 2, // ✨ add spacing between select and icon button
//                 }}
//               >
//                 {/* Language selector */}
//                 <select
//                   onChange={(e) => changeLanguage(e.target.value)}
//                   value={Cookies.get("i18next")}
//                   style={{
//                     padding: '5px',
//                     borderRadius: '4px',
//                   }}
//                 >
//                   <option value="en">English</option>
//                   <option value="el">Greek</option>
//                 </select>

//                 {/* Theme toggle button */}
//                 <Tooltip title={`Switch to ${mode === "light" ? "Dark" : "Light"} Mode`}>
//                   <IconButton onClick={toggleTheme} color="inherit">
//                     {mode === "light" ? <Brightness4Icon /> : <Brightness7Icon />}
//                   </IconButton>
//                 </Tooltip>
//               </Box>
//             </Box>
//           </Toolbar>
//         </AppBar>
//         {/* Navigation Drawer */}
//         <Box
//           component="nav"
//           sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
//           aria-label="mailbox folders"
//         >
//           {/* Mobile Drawer */}
//           <Drawer
//             variant="temporary"
//             open={mobileOpen}
//             onTransitionEnd={handleDrawerTransitionEnd}
//             onClose={handleDrawerClose}
//             ModalProps={{
//               keepMounted: true,
//             }}
//             sx={{
//               display: { xs: "block", sm: "none" },
//               "& .MuiDrawer-paper": {
//                 boxSizing: "border-box",
//                 width: drawerWidth,
//               },
//             }}
//           >
//             {drawer}
//           </Drawer>
//           {/* Desktop Drawer */}
//           <Drawer
//             variant="permanent"
//             sx={{
//               display: { xs: "none", sm: "block" },
//               "& .MuiDrawer-paper": {
//                 boxSizing: "border-box",
//                 width: drawerWidth,
//                 bgcolor: "background.default",
//                 borderRight: "1px solid #e0e0e0",
//               },
//             }}
//             open
//           >
//             {drawer}
//           </Drawer>
//         </Box>
//         {/* Main content area */}
//         <Box
//           component="main"
//           sx={{
//             flexGrow: 1,
//             p: 3,
//             width: { sm: `calc(100% - ${drawerWidth}px)` },
//             overflowX: "auto",
//           }}
//         >
//           <Toolbar />
//           {/* Conditional rendering based on view */}
//           {view === "appointments" ? (
//             <FullCalendarApp />
//           ) : view === "user_profile" ? (
//             <Profile />
//           ) : view === "clients" ? (
//             <Clients />
//           ) : view === "new_user" ? (
//             <UserForm />
//           ) : view === "staff" ? (
//             <Staff />
//           ) : view === "create_appointment" ? (
//             <AppointmentForm />
//           ) : view === "edit_delete_appointment" ? (
//             <EditDeleteAppointment
//               appointmentId={selectedAppointmentId}
//               onSave={handleSaveAppointment}
//               onDelete={handleDeleteAppointment}
//             />
//           ) : view === "reports" ? (
//             <Reports />
//           ) : view === "reset_password" ? (
//             <ResetPasswordForm />
//           ) : view === "make_excel_file" ? (
//             <MakeExcelFile />
//           ) : view === "send_email_sms" ? (
//             <SendEmailSMS />
//           ) : view === "assigned_client_stats" ? (
//             <AssignedClientStats />
//           ) : view === "client_stats" ? (
//             <ClientStats />
//           ) : view === "my_appointment" ? (
//             <AppointmentList />
//           ) : view === "edit_delete_user" ? (
//             <EditDeleteUsers />
//           ) : view === "notes" ? (
//             <Notes />
//           ) : view === "search_users" ? (
//             <SearchUsers />
//           ) : view === "gdpr_policy" ? (
//             <GDPRPOLICY />
//           ) : view === "appointment_list" ? (
//             <AppointmentListView />
//           ) : (
//             <Typography variant="h4">Oops something went wrong!</Typography>
//           )}
//         </Box>
//       </Box>
//     </div >
//   );
// }

// export default DrawerApp;

// import React, { useState, useEffect, useMemo, useCallback } from "react";
// import AppBar from "@mui/material/AppBar";
// import Box from "@mui/material/Box";
// import CssBaseline from "@mui/material/CssBaseline";
// import Divider from "@mui/material/Divider";
// import Drawer from "@mui/material/Drawer";
// import IconButton from "@mui/material/IconButton";
// import List from "@mui/material/List";
// import ListItem from "@mui/material/ListItem";
// import ListItemButton from "@mui/material/ListItemButton";
// import ListItemIcon from "@mui/material/ListItemIcon";
// import ListItemText from "@mui/material/ListItemText";
// import Toolbar from "@mui/material/Toolbar";
// import Typography from "@mui/material/Typography";
// import Menu from "@mui/material/Menu";
// import MenuItem from "@mui/material/MenuItem";
// import MenuIcon from "@mui/icons-material/Menu";
// import CalendarViewMonthIcon from "@mui/icons-material/CalendarViewMonth";
// import PersonIcon from "@mui/icons-material/Person";
// import PersonAddIcon from "@mui/icons-material/PersonAdd";
// import TransferWithinAStationIcon from "@mui/icons-material/TransferWithinAStation";
// import EditCalendarIcon from "@mui/icons-material/EditCalendar";
// import PasswordIcon from "@mui/icons-material/Password";
// import LogoutIcon from "@mui/icons-material/Logout";
// import AccountCircleIcon from "@mui/icons-material/AccountCircle";
// import SearchIcon from "@mui/icons-material/Search";
// import ListIcon from "@mui/icons-material/List"; // Appointment List
// import FullCalendarApp from "./FullCalendarApp";
// import Clients from "../screens/clients.screen";
// import UserForm from "../screens/new_client.screen";
// import AppointmentForm from "../screens/new_appointment.screen";
// import Staff from "../screens/staff.screen";
// import ResetPasswordForm from "../screens/reset_password.screen";
// import MakeExcelFile from "../screens/make.excel.file.screen";
// import Reports from "../screens/reports.screen";
// import AssignedClientStats from "../screens/AssignedClientStats";
// import EditDeleteAppointment from "../screens/EditDeleteAppointment";
// import ClientStats from "../screens/ClientStats";
// import EditDeleteUsers from "../screens/EditDeleteUsers";
// import SearchUsers from "../screens/SearchUsers";
// import SendEmailSMS from "../screens/SendEmailSMSExel";
// import AppointmentListView from "../screens/AppointmentListView"; // new component
// import { useTranslation } from "react-i18next";
// import Cookies from "js-cookie";
// import { useStateContext } from "../context/ContextProvider";
// import { LegendToggle, Note } from "@mui/icons-material";
// import AppointmentList from "../screens/AppointmentList";
// import Notes from "../screens/Notes";
// import axiosClient from "../axiosClient";
// import GDPRPOLICY from "../screens/GdprPolicyScreen";
// import GDPRPolicyLink from "./GDPRPolicyLink"; // 🔗 link component
// import Modal from "@mui/material/Modal";
// import ExpandLess from "@mui/icons-material/ExpandLess";
// import ExpandMore from "@mui/icons-material/ExpandMore";
// import Collapse from "@mui/material/Collapse";
// import Profile from "../screens/UserProfileScreen";
// import { useThemeContext } from "../context/ThemeContext";
// import { Tooltip, Button } from "@mui/material";


// import CreateIssueScreen from "./screens/create_issue.screen.jsx";
// // import { Tooltip, Button, Checkbox, FormControlLabel } from "@mui/material";

// import Brightness4Icon from "@mui/icons-material/Brightness4";
// import Brightness7Icon from "@mui/icons-material/Brightness7";
// import { useTheme } from "@mui/material/styles";

// // DrawerApp component: Main navigation and layout for the Patient Hub application
// function DrawerApp() {
//   // Access Material-UI theme
//   const theme = useTheme();
//   // Theme context for toggling light/dark mode
//   const { mode, toggleTheme } = useThemeContext();
//   // Drawer width configuration
//   const drawerWidth = 260;
//   // Context for user authentication and token management
//   const { user, _setUser, setToken, token } = useStateContext();
//   // State for mobile drawer visibility
//   const [mobileOpen, setMobileOpen] = useState(false);
//   // State to track drawer closing transition
//   const [isClosing, setIsClosing] = useState(false);
//   // State for selected appointment ID
//   const [selectedAppointmentId, setSelectedAppointmentId] = useState(null);
//   // State for GDPR modal visibility
//   const [showGDPRModal, setShowGDPRModal] = useState(false);
//   // State for GDPR agreement submission
//   const [isSubmittingAgreement, setIsSubmittingAgreement] = useState(false);
//   // State for monitoring submenu visibility
//   const [submenuOpen, setSubmenuOpen] = useState(false);
//   // State for user management menu visibility
//   const [userMenuOpen, setUserMenuOpen] = useState(false);
//   // State for appointments menu visibility
//   const [appointmentMenuOpen, setAppointmentMenuOpen] = useState(false);
//   // State for user menu anchor element
//   const [anchorEl, setAnchorEl] = useState(null);

//   // Context for view management
//   const { view, setView } = useStateContext();
//   const { t, i18n } = useTranslation();

//   // Effect to open relevant menus based on current view
//   useEffect(() => {
//     if (["clients", "search_users", "new_user", "edit_delete_user", "staff"].includes(view)) {
//       setUserMenuOpen(true);
//     }
//     if (
//       ["appointments", "my_appointment", "create_appointment", "edit_delete_appointment", "appointment_list"].includes(
//         view
//       )
//     ) {
//       setAppointmentMenuOpen(true);
//     }
//     if (["make_excel_file", "send_email_sms", "reports", "assigned_client_stats", "client_stats"].includes(view)) {
//       setSubmenuOpen(true);
//     }
//   }, [view]);

//   // Placeholder for user data refresh on page load
//   useEffect(() => {
//     // TODO: Implement API call to refresh user data using token from headers
//   }, []);

//   // Effect to show GDPR modal for clients who haven't accepted it
//   useEffect(() => {
//     if (user?.user_role === "CLIENT" && !user.gdpr_accepted) {
//       setShowGDPRModal(true);
//     }
//   }, [user]);

//   // Function to change application language
//   const changeLanguage = (lng) => {
//     i18n.changeLanguage(lng);
//   };

//   // Handle drawer close for mobile view
//   const handleDrawerClose = () => {
//     setIsClosing(true);
//     setMobileOpen(false);
//   };

//   // Handle drawer transition end
//   const handleDrawerTransitionEnd = () => {
//     setIsClosing(false);
//   };

//   // Toggle drawer visibility for mobile view
//   const handleDrawerToggle = () => {
//     if (!isClosing) {
//       setMobileOpen(!mobileOpen);
//     }
//   };

//   // Handle saving an appointment
//   const handleSaveAppointment = () => {
//     setSelectedAppointmentId(null);
//     setView("appointments");
//   };

//   // Handle deleting an appointment
//   const handleDeleteAppointment = () => {
//     setSelectedAppointmentId(null);
//     setView("appointments");
//   };

//   // Download GDPR report as PDF
//   const downloadGDPRreport = useCallback(async () => {
//     try {
//       const response = await axiosClient.get("api/gdpr-report", {
//         responseType: "blob",
//       });
//       const blob = new Blob([response.data], { type: "application/pdf" });
//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", `report.pdf`);
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       window.URL.revokeObjectURL(url);
//     } catch (error) {
//       console.error("Error downloading the PDF", error);
//     }
//   }, []);

//   // Handle GDPR agreement submission
//   const handleGDPRAgreement = async () => {
//     setIsSubmittingAgreement(true);
//     try {
//       const ipRes = await fetch("https://api.ipify.org?format=json");
//       const { ip } = await ipRes.json();
//       await axiosClient.post(
//         "/api/gdpr/accept/",
//         {
//           ip_address: ip,
//           agreement_time: new Date().toISOString(),
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Accept: "*/*",
//             Authorization: `JWT-${token}`,
//           },
//         }
//       );
//       _setUser({ ...user, gdpr_accepted: true });
//       setShowGDPRModal(false);
//     } catch (err) {
//       if (err.response && err.response.data) {
//         alert(err.response.data[0] || "Failed to accept GDPR.");
//       } else {
//         console.error("GDPR agreement failed:", err);
//       }
//     } finally {
//       setIsSubmittingAgreement(false);
//     }
//   };

//   // Open user profile menu
//   const handleUserMenuClick = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   // Close user profile menu
//   const handleUserMenuClose = () => {
//     setAnchorEl(null);
//   };

//   // Navigate to user profile view
//   const handleProfileClick = () => {
//     setView("user_profile");
//     handleUserMenuClose();
//   };

//   // Styles for active menu items
//   const activeItemStyle = {
//     bgcolor: "primary.main",
//     color: `${theme.palette.mode === "light" ? "black" : "white"}`,
//     "& .MuiListItemIcon-root": {
//       color: `${theme.palette.mode === "light" ? "black" : "white"}`,
//     },
//   };

//   // Check if a view is active
//   const isActive = (viewName) => view === viewName;

//   // Memoized primary menu items
//   const primaryMenuItems = useMemo(
//     () => [
//       {
//         name: t("Notes"),
//         icon: <Note />,
//         view: "notes",
//         handleClick: () => setView("notes"),
//         canSee: ["ADMIN"],
//       },
//     ],
//     [t, setView]
//   );

//   // Memoized GDPR menu items
//   const gdprMenuItems = useMemo(
//     () => [
//       {
//         name: t("GDPR REPORT"),
//         icon: <Note />,
//         view: null,
//         handleClick: () => downloadGDPRreport(),
//         canSee: ["CLIENT"],
//       },
//       {
//         name: t("GDPR POLICY"),
//         icon: <Note />,
//         view: "gdpr_policy",
//         handleClick: () => setView("gdpr_policy"),
//         canSee: ["ADMIN", "STAFF", "CLIENT"],
//       },
//     ],
//     [t, setView, downloadGDPRreport]
//   );

//   // Drawer content for navigation
//   const drawer = (
//     <div>
//       {/* User profile section */}
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           marginTop: 2,
//           marginBottom: 1,
//         }}
//       >
//         <ListItemButton
//           onClick={handleUserMenuClick}
//           sx={{
//             display: "flex",
//             alignItems: "center",
//           }}
//         >
//           <AccountCircleIcon />
//           <Typography variant="body2" align="center" sx={{ ml: 4, fontSize: "14px" }}>
//             {`${user.first_name} ${user.last_name}`}
//           </Typography>
//         </ListItemButton>
//         <Menu
//           anchorEl={anchorEl}
//           open={Boolean(anchorEl)}
//           onClose={handleUserMenuClose}
//           anchorOrigin={{
//             vertical: "bottom",
//             horizontal: "center",
//           }}
//           transformOrigin={{
//             vertical: "top",
//             horizontal: "center",
//           }}
//         >
//           <MenuItem onClick={handleProfileClick}>
//             <Typography variant="body2">{t("Profile")}</Typography>
//           </MenuItem>
//         </Menu>
//       </Box>
//       <Divider />

//       {/* Users Management menu for ADMIN and STAFF */}
//       {(user.user_role === "ADMIN" || user.user_role === "STAFF") && (
//         <>
//           <ListItemButton
//             sx={{
//               borderRadius: 2,
//               mx: 0,
//               my: 0.5,
//               "&:hover": {
//                 bgcolor: "action.hover",
//               },
//               ...(["clients", "search_users", "new_user", "edit_delete_user", "staff"].includes(view) && {
//                 bgcolor: "action.selected",
//               }),
//             }}
//             onClick={() => setUserMenuOpen(!userMenuOpen)}
//           >
//             <ListItemIcon>
//               <PersonIcon />
//             </ListItemIcon>
//             <ListItemText primary={t("Users Management")} primaryTypographyProps={{ variant: "body2" }} />
//             {userMenuOpen ? <ExpandLess /> : <ExpandMore />}
//           </ListItemButton>
//           <Collapse in={userMenuOpen} timeout={{ enter: 100, exit: 100 }} unmountOnExit>
//             <List component="div" disablePadding>
//               <ListItemButton
//                 sx={{
//                   pl: 4,
//                   ...(isActive("clients") && activeItemStyle),
//                 }}
//                 onClick={() => setView("clients")}
//                 selected={isActive("clients")}
//               >
//                 <ListItemIcon>
//                   <PersonIcon />
//                 </ListItemIcon>
//                 <ListItemText primary={t("Users")} primaryTypographyProps={{ variant: "body2" }} />
//               </ListItemButton>
//               <ListItemButton
//                 sx={{
//                   pl: 4,
//                   ...(isActive("search_users") && activeItemStyle),
//                 }}
//                 onClick={() => setView("search_users")}
//                 selected={isActive("search_users")}
//               >
//                 <ListItemIcon>
//                   <SearchIcon />
//                 </ListItemIcon>
//                 <ListItemText primary={t("Search Users")} primaryTypographyProps={{ variant: "body2" }} />
//               </ListItemButton>
//               <ListItemButton
//                 sx={{
//                   pl: 4,
//                   ...(isActive("new_user") && activeItemStyle),
//                 }}
//                 onClick={() => setView("new_user")}
//                 selected={isActive("new_user")}
//               >
//                 <ListItemIcon>
//                   <PersonAddIcon />
//                 </ListItemIcon>
//                 <ListItemText primary={t("New User")} primaryTypographyProps={{ variant: "body2" }} />
//               </ListItemButton>
//               <ListItemButton
//                 sx={{
//                   pl: 4,
//                   ...(isActive("edit_delete_user") && activeItemStyle),
//                 }}
//                 onClick={() => setView("edit_delete_user")}
//                 selected={isActive("edit_delete_user")}
//               >
//                 <ListItemIcon>
//                   <PersonIcon />
//                 </ListItemIcon>
//                 <ListItemText primary={t("Edit/Delete User")} primaryTypographyProps={{ variant: "body2" }} />
//               </ListItemButton>

//               {/* Clients to staff μέσα στο Users Management */}
//               <ListItemButton
//                 sx={{
//                   pl: 4,
//                   ...(isActive("staff") && activeItemStyle),
//                 }}
//                 onClick={() => setView("staff")}
//                 selected={isActive("staff")}
//               >
//                 <ListItemIcon>
//                   <TransferWithinAStationIcon />
//                 </ListItemIcon>
//                 <ListItemText primary={t("Clients to staff")} primaryTypographyProps={{ variant: "body2" }} />
//               </ListItemButton>
//             </List>
//           </Collapse>
//         </>
//       )}

//       {/* Appointments menu */}
//       <ListItemButton
//         sx={{
//           borderRadius: 2,
//           mx: 0,
//           my: 0.5,
//           "&:hover": {
//             bgcolor: "action.hover",
//           },
//           ...(
//             [
//               "appointments",
//               "my_appointment",
//               "create_appointment",
//               "edit_delete_appointment",
//               "appointment_list",
//             ].includes(view) && { bgcolor: "action.selected" }
//           ),
//         }}
//         onClick={() => setAppointmentMenuOpen(!appointmentMenuOpen)}
//       >
//         <ListItemIcon>
//           <CalendarViewMonthIcon />
//         </ListItemIcon>
//         <ListItemText primary={t("Appointments")} primaryTypographyProps={{ variant: "body2" }} />
//         {appointmentMenuOpen ? <ExpandLess /> : <ExpandMore />}
//       </ListItemButton>
//       <Collapse in={appointmentMenuOpen} timeout={{ enter: 100, exit: 100 }} unmountOnExit>
//         <List component="div" disablePadding>
//           <ListItemButton
//             sx={{
//               pl: 4,
//               ...(isActive("appointments") && activeItemStyle),
//             }}
//             onClick={() => setView("appointments")}
//             selected={isActive("appointments")}
//           >
//             <ListItemIcon>
//               <CalendarViewMonthIcon />
//             </ListItemIcon>
//             <ListItemText primary={t("View Appointments")} primaryTypographyProps={{ variant: "body2" }} />
//           </ListItemButton>
//           <ListItemButton
//             sx={{
//               pl: 4,
//               ...(isActive("appointment_list") && activeItemStyle),
//             }}
//             onClick={() => setView("appointment_list")}
//             selected={isActive("appointment_list")}
//           >
//             <ListItemIcon>
//               <ListIcon />
//             </ListItemIcon>
//             <ListItemText primary={t("Appointment List")} primaryTypographyProps={{ variant: "body2" }} />
//           </ListItemButton>
//           {user.user_role === "CLIENT" && (
//             <ListItemButton
//               sx={{
//                 pl: 4,
//                 ...(isActive("my_appointment") && activeItemStyle),
//               }}
//               onClick={() => setView("my_appointment")}
//               selected={isActive("my_appointment")}
//             >
//               <ListItemIcon>
//                 <CalendarViewMonthIcon />
//               </ListItemIcon>
//               <ListItemText primary={t("MY Appointments")} primaryTypographyProps={{ variant: "body2" }} />
//             </ListItemButton>
//           )}
//           {(user.user_role === "ADMIN" || user.user_role === "STAFF") && (
//             <>
//               <ListItemButton
//                 sx={{
//                   pl: 4,
//                   ...(isActive("create_appointment") && activeItemStyle),
//                 }}
//                 onClick={() => setView("create_appointment")}
//                 selected={isActive("create_appointment")}
//               >
//                 <ListItemIcon>
//                   <EditCalendarIcon />
//                 </ListItemIcon>
//                 <ListItemText primary={t("Create appointment")} primaryTypographyProps={{ variant: "body2" }} />
//               </ListItemButton>
//               <ListItemButton
//                 sx={{
//                   pl: 4,
//                   ...(isActive("edit_delete_appointment") && activeItemStyle),
//                 }}
//                 onClick={() => setView("edit_delete_appointment")}
//                 selected={isActive("edit_delete_appointment")}
//               >
//                 <ListItemIcon>
//                   <EditCalendarIcon />
//                 </ListItemIcon>
//                 <ListItemText primary={t("Edit/Delete appointment")} primaryTypographyProps={{ variant: "body2" }} />
//               </ListItemButton>
//             </>
//           )}
//         </List>
//       </Collapse>

//       {/* Primary menu items (Notes, etc.) */}
//       <List>
//         {primaryMenuItems.map((object) => {
//           if (object.canSee.includes(user.user_role)) {
//             return (
//               <ListItem key={object.name} disablePadding>
//                 <ListItemButton
//                   onClick={object.handleClick}
//                   sx={{
//                     ...(isActive(object.view) && activeItemStyle),
//                     borderRadius: 1,
//                   }}
//                   selected={isActive(object.view)}
//                 >
//                   <ListItemIcon>{object.icon}</ListItemIcon>
//                   <ListItemText primary={object.name} primaryTypographyProps={{ variant: "body2" }} />
//                 </ListItemButton>
//               </ListItem>
//             );
//           }
//           return null;
//         })}

//         {/* Monitoring submenu for ADMIN and STAFF */}
//         {(user.user_role === "ADMIN" || user.user_role === "STAFF") && (
//           <>
//             <ListItemButton
//               sx={{
//                 borderRadius: 2,
//                 mx: 0,
//                 my: 0.5,
//                 "&:hover": {
//                   bgcolor: "action.hover",
//                 },
//                 ...(
//                   ["make_excel_file", "send_email_sms", "reports", "assigned_client_stats", "client_stats"].includes(
//                     view
//                   ) && { bgcolor: "action.selected" }
//                 ),
//               }}
//               onClick={() => setSubmenuOpen(!submenuOpen)}
//             >
//               <ListItemIcon>
//                 <LegendToggle />
//               </ListItemIcon>
//               <ListItemText primary={t("Monitoring")} primaryTypographyProps={{ variant: "body2" }} />
//               {submenuOpen ? <ExpandLess /> : <ExpandMore />}
//             </ListItemButton>
//             <Collapse in={submenuOpen} timeout={{ enter: 100, exit: 100 }} unmountOnExit>
//               <List component="div" disablePadding>
//                 <ListItemButton
//                   sx={{
//                     pl: 4,
//                     ...(isActive("make_excel_file") && activeItemStyle),
//                   }}
//                   onClick={() => setView("make_excel_file")}
//                   selected={isActive("make_excel_file")}
//                 >
//                   <ListItemText inset primary={t("Make excel file")} primaryTypographyProps={{ variant: "body2" }} />
//                 </ListItemButton>
//                 <ListItemButton
//                   sx={{
//                     pl: 4,
//                     ...(isActive("send_email_sms") && activeItemStyle),
//                   }}
//                   onClick={() => setView("send_email_sms")}
//                   selected={isActive("send_email_sms")}
//                 >
//                   <ListItemText
//                     inset
//                     primary={t("Send Email/SMS excel file")}
//                     primaryTypographyProps={{ variant: "body2" }}
//                   />
//                 </ListItemButton>
//                 <ListItemButton
//                   sx={{
//                     pl: 4,
//                     ...(isActive("reports") && activeItemStyle),
//                   }}
//                   onClick={() => setView("reports")}
//                   selected={isActive("reports")}
//                 >
//                   <ListItemText inset primary={t("Reports")} primaryTypographyProps={{ variant: "body2" }} />
//                 </ListItemButton>
//                 <ListItemButton
//                   sx={{
//                     pl: 4,
//                     ...(isActive("assigned_client_stats") && activeItemStyle),
//                   }}
//                   onClick={() => setView("assigned_client_stats")}
//                   selected={isActive("assigned_client_stats")}
//                 >
//                   <ListItemText
//                     inset
//                     primary={t("Assigned Client Stats")}
//                     primaryTypographyProps={{ variant: "body2" }}
//                   />
//                 </ListItemButton>
//                 <ListItemButton
//                   sx={{
//                     pl: 4,
//                     ...(isActive("client_stats") && activeItemStyle),
//                   }}
//                   onClick={() => setView("client_stats")}
//                   selected={isActive("client_stats")}
//                 >
//                   <ListItemText inset primary={t("Client Stats")} primaryTypographyProps={{ variant: "body2" }} />
//                 </ListItemButton>
//               </List>
//             </Collapse>
//           </>
//         )}
//       </List>

//       {/* GDPR menu items */}
//       <List>
//         {gdprMenuItems.map((object) => {
//           if (object.canSee.includes(user.user_role)) {
//             return (
//               <ListItem key={object.name} disablePadding>
//                 <ListItemButton
//                   onClick={object.handleClick}
//                   sx={{
//                     ...(object.view && isActive(object.view) && activeItemStyle),
//                     borderRadius: 1,
//                   }}
//                   selected={object.view && isActive(object.view)}
//                 >
//                   <ListItemIcon>{object.icon}</ListItemIcon>
//                   <ListItemText primary={object.name} primaryTypographyProps={{ variant: "body2" }} />
//                 </ListItemButton>
//               </ListItem>
//             );
//           }
//           return null;
//         })}
//       </List>
//       <Divider />

//       {/* Reset password and logout options */}
//       <List>
//         {[
//           {
//             name: `${t("Reset password")}`,
//             icon: <PasswordIcon />,
//             view: "reset_password",
//             handleClick: () => setView("reset_password"),
//           },
//           {
//             name: `${t("Logout")}`,
//             icon: <LogoutIcon />,
//             view: null,
//             handleClick: () => {
//               setToken(null);
//               _setUser({});
//               window.location.reload();
//             },
//           },
//         ].map((object) => (
//           <ListItem key={object.name} disablePadding>
//             <ListItemButton
//               onClick={object.handleClick}
//               sx={{
//                 ...(object.view && isActive(object.view) && activeItemStyle),
//                 borderRadius: 1,
//               }}
//               selected={object.view && isActive(object.view)}
//             >
//               <ListItemIcon>{object.icon}</ListItemIcon>
//               <ListItemText primary={object.name} primaryTypographyProps={{ variant: "body2" }} />
//             </ListItemButton>
//           </ListItem>
//         ))}
//       </List>
//     </div>
//   );

//   // Main render
//   return (
//     <div className="App">
//       {/* GDPR Modal for clients */}
//       {showGDPRModal && (
//         <Modal open={showGDPRModal} onClose={() => {}} disableEscapeKeyDown>
//           <Box
//             sx={{
//               position: "absolute",
//               top: "50%",
//               left: "50%",
//               transform: "translate(-50%, -50%)",
//               width: "90%",
//               maxWidth: 600,
//               maxHeight: "90vh",
//               bgcolor: "background.paper",
//               boxShadow: 24,
//               p: 4,
//               overflowY: "auto",
//             }}
//           >
//             <Typography variant="h6" sx={{ mb: 2 }}>
//               {t("GDPR Title")}
//             </Typography>

//             <Typography variant="body2" sx={{ mb: 2 }}>
//               {t("GDPR Section 1 Intro P1")}
//             </Typography>

//             {/* 🔗 Link that opens the full GDPR policy in its own modal */}
//             <Box sx={{ mb: 3 }}>
//               <GDPRPolicyLink />
//             </Box>

//             <Typography variant="body2" sx={{ mb: 3 }}>
//               {t("Agreed to GDPR Policy?")}
//             </Typography>

//             <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
//               <Button
//                 variant="contained"
//                 color="primary"
//                 onClick={handleGDPRAgreement}
//                 disabled={isSubmittingAgreement}
//               >
//                 {t("Yes")}
//               </Button>
//             </Box>
//           </Box>
//         </Modal>
//       )}

//       <Box sx={{ display: "flex" }}>
//         <CssBaseline />
//         {/* Top AppBar */}
//         <AppBar
//           position="fixed"
//           sx={{
//             width: { sm: `calc(100% - ${drawerWidth}px)` },
//             ml: { sm: `${drawerWidth}px` },
//           }}
//         >
//           <Toolbar>
//             <IconButton
//               color="inherit"
//               aria-label="open drawer"
//               edge="start"
//               onClick={handleDrawerToggle}
//               sx={{ mr: 2, display: { sm: "none" } }}
//             >
//               <MenuIcon />
//             </IconButton>
//             <Box
//               sx={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 width: "90%",
//               }}
//             >
//               <Typography
//                 variant="h6"
//                 noWrap
//                 component="div"
//                 sx={{
//                   flexGrow: 1,
//                   mr: 2,
//                   fontFamily: "TempusFont, Arial, sans-serif",
//                   fontSize: "32px",
//                   fontWeight: 400,
//                   letterSpacing: "1px",
//                 }}
//               >
//                 Tempus Management System
//               </Typography>

//               <Box
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 2,
//                 }}
//               >
//                 {/* Language selector */}
//                 <select
//                   onChange={(e) => changeLanguage(e.target.value)}
//                   value={Cookies.get("i18next")}
//                   style={{
//                     padding: "5px",
//                     borderRadius: "4px",
//                   }}
//                 >
//                   <option value="en">English</option>
//                   <option value="el">Greek</option>
//                 </select>

//                 {/* Theme toggle button */}
//                 <Tooltip title={`Switch to ${mode === "light" ? "Dark" : "Light"} Mode`}>
//                   <IconButton onClick={toggleTheme} color="inherit">
//                     {mode === "light" ? <Brightness4Icon /> : <Brightness7Icon />}
//                   </IconButton>
//                 </Tooltip>
//               </Box>
//             </Box>
//           </Toolbar>
//         </AppBar>

//         {/* Navigation Drawer */}
//         <Box component="nav" sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }} aria-label="mailbox folders">
//           {/* Mobile Drawer */}
//           <Drawer
//             variant="temporary"
//             open={mobileOpen}
//             onTransitionEnd={handleDrawerTransitionEnd}
//             onClose={handleDrawerClose}
//             ModalProps={{
//               keepMounted: true,
//             }}
//             sx={{
//               display: { xs: "block", sm: "none" },
//               "& .MuiDrawer-paper": {
//                 boxSizing: "border-box",
//                 width: drawerWidth,
//               },
//             }}
//           >
//             {drawer}
//           </Drawer>
//           {/* Desktop Drawer */}
//           <Drawer
//             variant="permanent"
//             sx={{
//               display: { xs: "none", sm: "block" },
//               "& .MuiDrawer-paper": {
//                 boxSizing: "border-box",
//                 width: drawerWidth,
//                 bgcolor: "background.default",
//                 borderRight: "1px solid #e0e0e0",
//               },
//             }}
//             open
//           >
//             {drawer}
//           </Drawer>
//         </Box>

//         {/* Main content area */}
//         <Box
//           component="main"
//           sx={{
//             flexGrow: 1,
//             p: 3,
//             width: { sm: `calc(100% - ${drawerWidth}px)` },
//             overflowX: "auto",
//           }}
//         >
//           <Toolbar />
//           {/* Conditional rendering based on view */}
//           {view === "appointments" ? (
//             <FullCalendarApp />
//           ) : view === "user_profile" ? (
//             <Profile />
//           ) : view === "clients" ? (
//             <Clients />
//           ) : view === "new_user" ? (
//             <UserForm />
//           ) : view === "staff" ? (
//             <Staff />
//           ) : view === "create_appointment" ? (
//             <AppointmentForm />
//           ) : view === "edit_delete_appointment" ? (
//             <EditDeleteAppointment
//               appointmentId={selectedAppointmentId}
//               onSave={handleSaveAppointment}
//               onDelete={handleDeleteAppointment}
//             />
//           ) : view === "reports" ? (
//             <Reports />
//           ) : view === "reset_password" ? (
//             <ResetPasswordForm />
//           ) : view === "make_excel_file" ? (
//             <MakeExcelFile />
//           ) : view === "send_email_sms" ? (
//             <SendEmailSMS />
//           ) : view === "assigned_client_stats" ? (
//             <AssignedClientStats />
//           ) : view === "client_stats" ? (
//             <ClientStats />
//           ) : view === "my_appointment" ? (
//             <AppointmentList />
//           ) : view === "edit_delete_user" ? (
//             <EditDeleteUsers />
//           ) : view === "notes" ? (
//             <Notes />
//           ) : view === "search_users" ? (
//             <SearchUsers />
//           ) : view === "gdpr_policy" ? (
//             <GDPRPOLICY />
//           ) : view === "appointment_list" ? (
//             <AppointmentListView />
//           ) : (
//             <Typography variant="h4">Oops something went wrong!</Typography>
//           )}
//         </Box>
//       </Box>
//     </div>
//   );
// }

// export default DrawerApp;

// import React, { useState, useEffect, useMemo, useCallback } from "react";
// import AppBar from "@mui/material/AppBar";
// import Box from "@mui/material/Box";
// import CssBaseline from "@mui/material/CssBaseline";
// import Divider from "@mui/material/Divider";
// import Drawer from "@mui/material/Drawer";
// import IconButton from "@mui/material/IconButton";
// import List from "@mui/material/List";
// import ListItem from "@mui/material/ListItem";
// import ListItemButton from "@mui/material/ListItemButton";
// import ListItemIcon from "@mui/material/ListItemIcon";
// import ListItemText from "@mui/material/ListItemText";
// import Toolbar from "@mui/material/Toolbar";
// import Typography from "@mui/material/Typography";
// import Menu from "@mui/material/Menu";
// import MenuItem from "@mui/material/MenuItem";
// import MenuIcon from "@mui/icons-material/Menu";
// import CalendarViewMonthIcon from "@mui/icons-material/CalendarViewMonth";
// import PersonIcon from "@mui/icons-material/Person";
// import PersonAddIcon from "@mui/icons-material/PersonAdd";
// import TransferWithinAStationIcon from "@mui/icons-material/TransferWithinAStation";
// import EditCalendarIcon from "@mui/icons-material/EditCalendar";
// import PasswordIcon from "@mui/icons-material/Password";
// import LogoutIcon from "@mui/icons-material/Logout";
// import AccountCircleIcon from "@mui/icons-material/AccountCircle";
// import SearchIcon from "@mui/icons-material/Search";
// import ListIcon from "@mui/icons-material/List"; // Appointment List
// import BugReportIcon from "@mui/icons-material/BugReport"; // ✅ Create Issue icon

// import FullCalendarApp from "./FullCalendarApp";
// import Clients from "../screens/clients.screen";
// import UserForm from "../screens/new_client.screen";
// import AppointmentForm from "../screens/new_appointment.screen";
// import Staff from "../screens/staff.screen";
// import ResetPasswordForm from "../screens/reset_password.screen";
// import MakeExcelFile from "../screens/make.excel.file.screen";
// import Reports from "../screens/reports.screen";
// import AssignedClientStats from "../screens/AssignedClientStats";
// import EditDeleteAppointment from "../screens/EditDeleteAppointment";
// import ClientStats from "../screens/ClientStats";
// import EditDeleteUsers from "../screens/EditDeleteUsers";
// import SearchUsers from "../screens/SearchUsers";
// import SendEmailSMS from "../screens/SendEmailSMSExel";
// import AppointmentListView from "../screens/AppointmentListView"; // new component
// import AppointmentList from "../screens/AppointmentList";
// import Notes from "../screens/Notes";
// import GDPRPOLICY from "../screens/GdprPolicyScreen";
// import Profile from "../screens/UserProfileScreen";
// import ServiceIssues from "../screens/ServiceIssues/ServiceIssues";


// // ✅ FIXED import path (from screens, not components)
// import CreateIssueScreen from "../screens/create_issue.screen";

// import { useTranslation } from "react-i18next";
// import Cookies from "js-cookie";
// import { useStateContext } from "../context/ContextProvider";
// import { LegendToggle, Note } from "@mui/icons-material";
// import axiosClient from "../axiosClient";
// import GDPRPolicyLink from "./GDPRPolicyLink"; // 🔗 link component
// import Modal from "@mui/material/Modal";
// import ExpandLess from "@mui/icons-material/ExpandLess";
// import ExpandMore from "@mui/icons-material/ExpandMore";
// import Collapse from "@mui/material/Collapse";
// import { useThemeContext } from "../context/ThemeContext";
// import { Tooltip, Button } from "@mui/material";

// import Brightness4Icon from "@mui/icons-material/Brightness4";
// import Brightness7Icon from "@mui/icons-material/Brightness7";
// import { useTheme } from "@mui/material/styles";

// function DrawerApp() {
//   const theme = useTheme();
//   const { mode, toggleTheme } = useThemeContext();
//   const drawerWidth = 260;
//   const { user, _setUser, setToken, token } = useStateContext();

//   const [mobileOpen, setMobileOpen] = useState(false);
//   const [isClosing, setIsClosing] = useState(false);

//   const [selectedAppointmentId, setSelectedAppointmentId] = useState(null);
//   const [showGDPRModal, setShowGDPRModal] = useState(false);
//   const [isSubmittingAgreement, setIsSubmittingAgreement] = useState(false);

//   const [submenuOpen, setSubmenuOpen] = useState(false);
//   const [userMenuOpen, setUserMenuOpen] = useState(false);
//   const [appointmentMenuOpen, setAppointmentMenuOpen] = useState(false);
//   const [anchorEl, setAnchorEl] = useState(null);

//   const { view, setView } = useStateContext();
//   const { t, i18n } = useTranslation();

//   useEffect(() => {
//     if (["clients", "search_users", "new_user", "edit_delete_user", "staff"].includes(view)) {
//       setUserMenuOpen(true);
//     }
//     if (
//       ["appointments", "my_appointment", "create_appointment", "edit_delete_appointment", "appointment_list"].includes(
//         view
//       )
//     ) {
//       setAppointmentMenuOpen(true);
//     }
//     // ✅ Add create_issue to Monitoring group so submenu opens when active
//     if (
//       ["make_excel_file", "send_email_sms", "reports", "assigned_client_stats", "client_stats", "create_issue"].includes(
//         view
//       )
//     ) {
//       setSubmenuOpen(true);
//     }
//   }, [view]);

//   useEffect(() => {}, []);

//   useEffect(() => {
//     if (user?.user_role === "CLIENT" && !user.gdpr_accepted) {
//       setShowGDPRModal(true);
//     }
//   }, [user]);

//   const changeLanguage = (lng) => {
//     i18n.changeLanguage(lng);
//   };

//   const handleDrawerClose = () => {
//     setIsClosing(true);
//     setMobileOpen(false);
//   };

//   const handleDrawerTransitionEnd = () => {
//     setIsClosing(false);
//   };

//   const handleDrawerToggle = () => {
//     if (!isClosing) {
//       setMobileOpen(!mobileOpen);
//     }
//   };

//   const handleSaveAppointment = () => {
//     setSelectedAppointmentId(null);
//     setView("appointments");
//   };

//   const handleDeleteAppointment = () => {
//     setSelectedAppointmentId(null);
//     setView("appointments");
//   };

//   const downloadGDPRreport = useCallback(async () => {
//     try {
//       const response = await axiosClient.get("api/gdpr-report", {
//         responseType: "blob",
//       });
//       const blob = new Blob([response.data], { type: "application/pdf" });
//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", `report.pdf`);
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       window.URL.revokeObjectURL(url);
//     } catch (error) {
//       console.error("Error downloading the PDF", error);
//     }
//   }, []);

//   const handleGDPRAgreement = async () => {
//     setIsSubmittingAgreement(true);
//     try {
//       const ipRes = await fetch("https://api.ipify.org?format=json");
//       const { ip } = await ipRes.json();
//       await axiosClient.post(
//         "/api/gdpr/accept/",
//         { ip_address: ip, agreement_time: new Date().toISOString() },
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Accept: "*/*",
//             Authorization: `JWT-${token}`,
//           },
//         }
//       );
//       _setUser({ ...user, gdpr_accepted: true });
//       setShowGDPRModal(false);
//     } catch (err) {
//       if (err.response && err.response.data) {
//         alert(err.response.data[0] || "Failed to accept GDPR.");
//       } else {
//         console.error("GDPR agreement failed:", err);
//       }
//     } finally {
//       setIsSubmittingAgreement(false);
//     }
//   };

//   const handleUserMenuClick = (event) => setAnchorEl(event.currentTarget);
//   const handleUserMenuClose = () => setAnchorEl(null);

//   const handleProfileClick = () => {
//     setView("user_profile");
//     handleUserMenuClose();
//   };

//   const activeItemStyle = {
//     bgcolor: "primary.main",
//     color: `${theme.palette.mode === "light" ? "black" : "white"}`,
//     "& .MuiListItemIcon-root": {
//       color: `${theme.palette.mode === "light" ? "black" : "white"}`,
//     },
//   };

//   const isActive = (viewName) => view === viewName;

//   const primaryMenuItems = useMemo(
//     () => [
//       {
//         name: t("Notes"),
//         icon: <Note />,
//         view: "notes",
//         handleClick: () => setView("notes"),
//         canSee: ["ADMIN"],
//       },
//     ],
//     [t, setView]
//   );

//   const gdprMenuItems = useMemo(
//     () => [
//       {
//         name: t("GDPR REPORT"),
//         icon: <Note />,
//         view: null,
//         handleClick: () => downloadGDPRreport(),
//         canSee: ["CLIENT"],
//       },
//       {
//         name: t("GDPR POLICY"),
//         icon: <Note />,
//         view: "gdpr_policy",
//         handleClick: () => setView("gdpr_policy"),
//         canSee: ["ADMIN", "STAFF", "CLIENT"],
//       },
//     ],
//     [t, setView, downloadGDPRreport]
//   );

//   const drawer = (
//     <div>
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           marginTop: 2,
//           marginBottom: 1,
//         }}
//       >
//         <ListItemButton
//           onClick={handleUserMenuClick}
//           sx={{ display: "flex", alignItems: "center" }}
//         >
//           <AccountCircleIcon />
//           <Typography variant="body2" align="center" sx={{ ml: 4, fontSize: "14px" }}>
//             {`${user.first_name} ${user.last_name}`}
//           </Typography>
//         </ListItemButton>

//         <Menu
//           anchorEl={anchorEl}
//           open={Boolean(anchorEl)}
//           onClose={handleUserMenuClose}
//           anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//           transformOrigin={{ vertical: "top", horizontal: "center" }}
//         >
//           <MenuItem onClick={handleProfileClick}>
//             <Typography variant="body2">{t("Profile")}</Typography>
//           </MenuItem>
//         </Menu>
//       </Box>

//       <Divider />

//       {(user.user_role === "ADMIN" || user.user_role === "STAFF") && (
//         <>
//           <ListItemButton
//             sx={{
//               borderRadius: 2,
//               mx: 0,
//               my: 0.5,
//               "&:hover": { bgcolor: "action.hover" },
//               ...(["clients", "search_users", "new_user", "edit_delete_user", "staff"].includes(view) && {
//                 bgcolor: "action.selected",
//               }),
//             }}
//             onClick={() => setUserMenuOpen(!userMenuOpen)}
//           >
//             <ListItemIcon>
//               <PersonIcon />
//             </ListItemIcon>
//             <ListItemText primary={t("Users Management")} primaryTypographyProps={{ variant: "body2" }} />
//             {userMenuOpen ? <ExpandLess /> : <ExpandMore />}
//           </ListItemButton>

//           <Collapse in={userMenuOpen} timeout={{ enter: 100, exit: 100 }} unmountOnExit>
//             <List component="div" disablePadding>
//               <ListItemButton
//                 sx={{ pl: 4, ...(isActive("clients") && activeItemStyle) }}
//                 onClick={() => setView("clients")}
//                 selected={isActive("clients")}
//               >
//                 <ListItemIcon>
//                   <PersonIcon />
//                 </ListItemIcon>
//                 <ListItemText primary={t("Users")} primaryTypographyProps={{ variant: "body2" }} />
//               </ListItemButton>

//               <ListItemButton
//                 sx={{ pl: 4, ...(isActive("search_users") && activeItemStyle) }}
//                 onClick={() => setView("search_users")}
//                 selected={isActive("search_users")}
//               >
//                 <ListItemIcon>
//                   <SearchIcon />
//                 </ListItemIcon>
//                 <ListItemText primary={t("Search Users")} primaryTypographyProps={{ variant: "body2" }} />
//               </ListItemButton>

//               <ListItemButton
//                 sx={{ pl: 4, ...(isActive("new_user") && activeItemStyle) }}
//                 onClick={() => setView("new_user")}
//                 selected={isActive("new_user")}
//               >
//                 <ListItemIcon>
//                   <PersonAddIcon />
//                 </ListItemIcon>
//                 <ListItemText primary={t("New User")} primaryTypographyProps={{ variant: "body2" }} />
//               </ListItemButton>

//               <ListItemButton
//                 sx={{ pl: 4, ...(isActive("edit_delete_user") && activeItemStyle) }}
//                 onClick={() => setView("edit_delete_user")}
//                 selected={isActive("edit_delete_user")}
//               >
//                 <ListItemIcon>
//                   <PersonIcon />
//                 </ListItemIcon>
//                 <ListItemText primary={t("Edit/Delete User")} primaryTypographyProps={{ variant: "body2" }} />
//               </ListItemButton>

//               <ListItemButton
//                 sx={{ pl: 4, ...(isActive("staff") && activeItemStyle) }}
//                 onClick={() => setView("staff")}
//                 selected={isActive("staff")}
//               >
//                 <ListItemIcon>
//                   <TransferWithinAStationIcon />
//                 </ListItemIcon>
//                 <ListItemText primary={t("Clients to staff")} primaryTypographyProps={{ variant: "body2" }} />
//               </ListItemButton>
//             </List>
//           </Collapse>
//         </>
//       )}

//       <ListItemButton
//         sx={{
//           borderRadius: 2,
//           mx: 0,
//           my: 0.5,
//           "&:hover": { bgcolor: "action.hover" },
//           ...(
//             ["appointments", "my_appointment", "create_appointment", "edit_delete_appointment", "appointment_list"].includes(view) && {
//               bgcolor: "action.selected",
//             }
//           ),
//         }}
//         onClick={() => setAppointmentMenuOpen(!appointmentMenuOpen)}
//       >
//         <ListItemIcon>
//           <CalendarViewMonthIcon />
//         </ListItemIcon>
//         <ListItemText primary={t("Appointments")} primaryTypographyProps={{ variant: "body2" }} />
//         {appointmentMenuOpen ? <ExpandLess /> : <ExpandMore />}
//       </ListItemButton>

//       <Collapse in={appointmentMenuOpen} timeout={{ enter: 100, exit: 100 }} unmountOnExit>
//         <List component="div" disablePadding>
//           <ListItemButton
//             sx={{ pl: 4, ...(isActive("appointments") && activeItemStyle) }}
//             onClick={() => setView("appointments")}
//             selected={isActive("appointments")}
//           >
//             <ListItemIcon>
//               <CalendarViewMonthIcon />
//             </ListItemIcon>
//             <ListItemText primary={t("View Appointments")} primaryTypographyProps={{ variant: "body2" }} />
//           </ListItemButton>

//           <ListItemButton
//             sx={{ pl: 4, ...(isActive("appointment_list") && activeItemStyle) }}
//             onClick={() => setView("appointment_list")}
//             selected={isActive("appointment_list")}
//           >
//             <ListItemIcon>
//               <ListIcon />
//             </ListItemIcon>
//             <ListItemText primary={t("Appointment List")} primaryTypographyProps={{ variant: "body2" }} />
//           </ListItemButton>

//           {user.user_role === "CLIENT" && (
//             <ListItemButton
//               sx={{ pl: 4, ...(isActive("my_appointment") && activeItemStyle) }}
//               onClick={() => setView("my_appointment")}
//               selected={isActive("my_appointment")}
//             >
//               <ListItemIcon>
//                 <CalendarViewMonthIcon />
//               </ListItemIcon>
//               <ListItemText primary={t("MY Appointments")} primaryTypographyProps={{ variant: "body2" }} />
//             </ListItemButton>
//           )}

//           {(user.user_role === "ADMIN" || user.user_role === "STAFF") && (
//             <>
//               <ListItemButton
//                 sx={{ pl: 4, ...(isActive("create_appointment") && activeItemStyle) }}
//                 onClick={() => setView("create_appointment")}
//                 selected={isActive("create_appointment")}
//               >
//                 <ListItemIcon>
//                   <EditCalendarIcon />
//                 </ListItemIcon>
//                 <ListItemText primary={t("Create appointment")} primaryTypographyProps={{ variant: "body2" }} />
//               </ListItemButton>

//               <ListItemButton
//                 sx={{ pl: 4, ...(isActive("edit_delete_appointment") && activeItemStyle) }}
//                 onClick={() => setView("edit_delete_appointment")}
//                 selected={isActive("edit_delete_appointment")}
//               >
//                 <ListItemIcon>
//                   <EditCalendarIcon />
//                 </ListItemIcon>
//                 <ListItemText primary={t("Edit/Delete appointment")} primaryTypographyProps={{ variant: "body2" }} />
//               </ListItemButton>
//             </>
//           )}
//         </List>
//       </Collapse>

//       <List>
//         {primaryMenuItems.map((object) => {
//           if (object.canSee.includes(user.user_role)) {
//             return (
//               <ListItem key={object.name} disablePadding>
//                 <ListItemButton
//                   onClick={object.handleClick}
//                   sx={{ ...(isActive(object.view) && activeItemStyle), borderRadius: 1 }}
//                   selected={isActive(object.view)}
//                 >
//                   <ListItemIcon>{object.icon}</ListItemIcon>
//                   <ListItemText primary={object.name} primaryTypographyProps={{ variant: "body2" }} />
//                 </ListItemButton>
//               </ListItem>
//             );
//           }
//           return null;
//         })}

//         {(user.user_role === "ADMIN" || user.user_role === "STAFF") && (
//           <>
//             <ListItemButton
//               sx={{
//                 borderRadius: 2,
//                 mx: 0,
//                 my: 0.5,
//                 "&:hover": { bgcolor: "action.hover" },
//                 ...(
//                   ["make_excel_file", "send_email_sms", "reports", "assigned_client_stats", "client_stats", "create_issue"].includes(
//                     view
//                   ) && { bgcolor: "action.selected" }
//                 ),
//               }}
//               onClick={() => setSubmenuOpen(!submenuOpen)}
//             >
//               <ListItemIcon>
//                 <LegendToggle />
//               </ListItemIcon>
//               <ListItemText primary={t("Monitoring")} primaryTypographyProps={{ variant: "body2" }} />
//               {submenuOpen ? <ExpandLess /> : <ExpandMore />}
//             </ListItemButton>

//             <Collapse in={submenuOpen} timeout={{ enter: 100, exit: 100 }} unmountOnExit>
//               <List component="div" disablePadding>
//                 <ListItemButton
//                   sx={{ pl: 4, ...(isActive("make_excel_file") && activeItemStyle) }}
//                   onClick={() => setView("make_excel_file")}
//                   selected={isActive("make_excel_file")}
//                 >
//                   <ListItemText inset primary={t("Make excel file")} primaryTypographyProps={{ variant: "body2" }} />
//                 </ListItemButton>

//                 <ListItemButton
//                   sx={{ pl: 4, ...(isActive("send_email_sms") && activeItemStyle) }}
//                   onClick={() => setView("send_email_sms")}
//                   selected={isActive("send_email_sms")}
//                 >
//                   <ListItemText
//                     inset
//                     primary={t("Send Email/SMS excel file")}
//                     primaryTypographyProps={{ variant: "body2" }}
//                   />
//                 </ListItemButton>

//                 <ListItemButton
//                   sx={{ pl: 4, ...(isActive("reports") && activeItemStyle) }}
//                   onClick={() => setView("reports")}
//                   selected={isActive("reports")}
//                 >
//                   <ListItemText inset primary={t("Reports")} primaryTypographyProps={{ variant: "body2" }} />
//                 </ListItemButton>

//                 <ListItemButton
//                   sx={{ pl: 4, ...(isActive("assigned_client_stats") && activeItemStyle) }}
//                   onClick={() => setView("assigned_client_stats")}
//                   selected={isActive("assigned_client_stats")}
//                 >
//                   <ListItemText
//                     inset
//                     primary={t("Assigned Client Stats")}
//                     primaryTypographyProps={{ variant: "body2" }}
//                   />
//                 </ListItemButton>

//                 <ListItemButton
//                   sx={{ pl: 4, ...(isActive("client_stats") && activeItemStyle) }}
//                   onClick={() => setView("client_stats")}
//                   selected={isActive("client_stats")}
//                 >
//                   <ListItemText inset primary={t("Client Stats")} primaryTypographyProps={{ variant: "body2" }} />
//                 </ListItemButton>

//                 {/* ✅ NEW MENU ITEM: Create Issue */}
//                 <ListItemButton
//                   sx={{ pl: 4, ...(isActive("create_issue") && activeItemStyle) }}
//                   onClick={() => setView("create_issue")}
//                   selected={isActive("create_issue")}
//                 >
//                   <ListItemIcon>
//                     <BugReportIcon />
//                   </ListItemIcon>
//                   <ListItemText primary={t("Create Issue")} primaryTypographyProps={{ variant: "body2" }} />
//                 </ListItemButton>
//               </List>
//             </Collapse>
//           </>
//         )}
//       </List>

//       <List>
//         {gdprMenuItems.map((object) => {
//           if (object.canSee.includes(user.user_role)) {
//             return (
//               <ListItem key={object.name} disablePadding>
//                 <ListItemButton
//                   onClick={object.handleClick}
//                   sx={{ ...(object.view && isActive(object.view) && activeItemStyle), borderRadius: 1 }}
//                   selected={object.view && isActive(object.view)}
//                 >
//                   <ListItemIcon>{object.icon}</ListItemIcon>
//                   <ListItemText primary={object.name} primaryTypographyProps={{ variant: "body2" }} />
//                 </ListItemButton>
//               </ListItem>
//             );
//           }
//           return null;
//         })}
//       </List>

//       <Divider />

//       <List>
//         {[
//           {
//             name: `${t("Reset password")}`,
//             icon: <PasswordIcon />,
//             view: "reset_password",
//             handleClick: () => setView("reset_password"),
//           },
//           {
//             name: `${t("Logout")}`,
//             icon: <LogoutIcon />,
//             view: null,
//             handleClick: () => {
//               setToken(null);
//               _setUser({});
//               window.location.reload();
//             },
//           },
//         ].map((object) => (
//           <ListItem key={object.name} disablePadding>
//             <ListItemButton
//               onClick={object.handleClick}
//               sx={{ ...(object.view && isActive(object.view) && activeItemStyle), borderRadius: 1 }}
//               selected={object.view && isActive(object.view)}
//             >
//               <ListItemIcon>{object.icon}</ListItemIcon>
//               <ListItemText primary={object.name} primaryTypographyProps={{ variant: "body2" }} />
//             </ListItemButton>
//           </ListItem>
//         ))}
//       </List>
//     </div>
//   );

//   return (
//     <div className="App">
//       {showGDPRModal && (
//         <Modal open={showGDPRModal} onClose={() => {}} disableEscapeKeyDown>
//           <Box
//             sx={{
//               position: "absolute",
//               top: "50%",
//               left: "50%",
//               transform: "translate(-50%, -50%)",
//               width: "90%",
//               maxWidth: 600,
//               maxHeight: "90vh",
//               bgcolor: "background.paper",
//               boxShadow: 24,
//               p: 4,
//               overflowY: "auto",
//             }}
//           >
//             <Typography variant="h6" sx={{ mb: 2 }}>
//               {t("GDPR Title")}
//             </Typography>

//             <Typography variant="body2" sx={{ mb: 2 }}>
//               {t("GDPR Section 1 Intro P1")}
//             </Typography>

//             <Box sx={{ mb: 3 }}>
//               <GDPRPolicyLink />
//             </Box>

//             <Typography variant="body2" sx={{ mb: 3 }}>
//               {t("Agreed to GDPR Policy?")}
//             </Typography>

//             <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
//               <Button variant="contained" color="primary" onClick={handleGDPRAgreement} disabled={isSubmittingAgreement}>
//                 {t("Yes")}
//               </Button>
//             </Box>
//           </Box>
//         </Modal>
//       )}

//       <Box sx={{ display: "flex" }}>
//         <CssBaseline />

//         <AppBar
//           position="fixed"
//           sx={{
//             width: { sm: `calc(100% - ${drawerWidth}px)` },
//             ml: { sm: `${drawerWidth}px` },
//           }}
//         >
//           <Toolbar>
//             <IconButton
//               color="inherit"
//               aria-label="open drawer"
//               edge="start"
//               onClick={handleDrawerToggle}
//               sx={{ mr: 2, display: { sm: "none" } }}
//             >
//               <MenuIcon />
//             </IconButton>

//             <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "90%" }}>
//               <Typography
//                 variant="h6"
//                 noWrap
//                 component="div"
//                 sx={{
//                   flexGrow: 1,
//                   mr: 2,
//                   fontFamily: "TempusFont, Arial, sans-serif",
//                   fontSize: "32px",
//                   fontWeight: 400,
//                   letterSpacing: "1px",
//                 }}
//               >
//                 Tempus Management System
//               </Typography>

//               <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                 <select
//                   onChange={(e) => changeLanguage(e.target.value)}
//                   value={Cookies.get("i18next")}
//                   style={{ padding: "5px", borderRadius: "4px" }}
//                 >
//                   <option value="en">English</option>
//                   <option value="el">Greek</option>
//                 </select>

//                 <Tooltip title={`Switch to ${mode === "light" ? "Dark" : "Light"} Mode`}>
//                   <IconButton onClick={toggleTheme} color="inherit">
//                     {mode === "light" ? <Brightness4Icon /> : <Brightness7Icon />}
//                   </IconButton>
//                 </Tooltip>
//               </Box>
//             </Box>
//           </Toolbar>
//         </AppBar>

//         <Box component="nav" sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }} aria-label="mailbox folders">
//           <Drawer
//             variant="temporary"
//             open={mobileOpen}
//             onTransitionEnd={handleDrawerTransitionEnd}
//             onClose={handleDrawerClose}
//             ModalProps={{ keepMounted: true }}
//             sx={{
//               display: { xs: "block", sm: "none" },
//               "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth },
//             }}
//           >
//             {drawer}
//           </Drawer>

//           <Drawer
//             variant="permanent"
//             sx={{
//               display: { xs: "none", sm: "block" },
//               "& .MuiDrawer-paper": {
//                 boxSizing: "border-box",
//                 width: drawerWidth,
//                 bgcolor: "background.default",
//                 borderRight: "1px solid #e0e0e0",
//               },
//             }}
//             open
//           >
//             {drawer}
//           </Drawer>
//         </Box>

//         <Box
//           component="main"
//           sx={{
//             flexGrow: 1,
//             p: 3,
//             width: { sm: `calc(100% - ${drawerWidth}px)` },
//             overflowX: "auto",
//           }}
//         >
//           <Toolbar />

//           {view === "appointments" ? (
//             <FullCalendarApp />
//           ) : view === "user_profile" ? (
//             <Profile />
//           ) : view === "clients" ? (
//             <Clients />
//           ) : view === "new_user" ? (
//             <UserForm />
//           ) : view === "staff" ? (
//             <Staff />
//           ) : view === "create_appointment" ? (
//             <AppointmentForm />
//           ) : view === "edit_delete_appointment" ? (
//             <EditDeleteAppointment
//               appointmentId={selectedAppointmentId}
//               onSave={handleSaveAppointment}
//               onDelete={handleDeleteAppointment}
//             />
//           ) : view === "reports" ? (
//             <Reports />
//           ) : view === "reset_password" ? (
//             <ResetPasswordForm />
//           ) : view === "make_excel_file" ? (
//             <MakeExcelFile />
//           ) : view === "send_email_sms" ? (
//             <SendEmailSMS />
//           ) : view === "assigned_client_stats" ? (
//             <AssignedClientStats />
//           ) : view === "client_stats" ? (
//             <ClientStats />
//           ) : view === "my_appointment" ? (
//             <AppointmentList />
//           ) : view === "edit_delete_user" ? (
//             <EditDeleteUsers />
//           ) : view === "notes" ? (
//             <Notes />
//           ) : view === "search_users" ? (
//             <SearchUsers />
//           ) : view === "gdpr_policy" ? (
//             <GDPRPOLICY />
//           ) : view === "appointment_list" ? (
//             <AppointmentListView />
//           ) : view === "create_issue" ? (
//             <CreateIssueScreen />
//           ) : (
//             <Typography variant="h4">Oops something went wrong!</Typography>
//           )}
//         </Box>
//       </Box>
//     </div>
//   );
// }

// export default DrawerApp;

// src/components/DrawerApp.js

import React, { useState, useEffect, useMemo, useCallback } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MenuIcon from "@mui/icons-material/Menu";
import CalendarViewMonthIcon from "@mui/icons-material/CalendarViewMonth";
import PersonIcon from "@mui/icons-material/Person";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import TransferWithinAStationIcon from "@mui/icons-material/TransferWithinAStation";
import EditCalendarIcon from "@mui/icons-material/EditCalendar";
import PasswordIcon from "@mui/icons-material/Password";
import LogoutIcon from "@mui/icons-material/Logout";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import SearchIcon from "@mui/icons-material/Search";
import ListIcon from "@mui/icons-material/List";
import BugReportIcon from "@mui/icons-material/BugReport";

import FullCalendarApp from "./FullCalendarApp";
import Clients from "../screens/clients.screen";
import UserForm from "../screens/new_client.screen";
import AppointmentForm from "../screens/new_appointment.screen";
import Staff from "../screens/staff.screen";
import ResetPasswordForm from "../screens/reset_password.screen";
import MakeExcelFile from "../screens/make.excel.file.screen";
import Reports from "../screens/reports.screen";
import AssignedClientStats from "../screens/AssignedClientStats";
import EditDeleteAppointment from "../screens/EditDeleteAppointment";
import ClientStats from "../screens/ClientStats";
import EditDeleteUsers from "../screens/EditDeleteUsers";
import SearchUsers from "../screens/SearchUsers";
import SendEmailSMS from "../screens/SendEmailSMSExel";
import AppointmentListView from "../screens/AppointmentListView";
import AppointmentList from "../screens/AppointmentList";
import Notes from "../screens/Notes";
import GDPRPOLICY from "../screens/GdprPolicyScreen";
import Profile from "../screens/UserProfileScreen";
import ServiceIssues from "../ServiceIssues/ServiceIssues"; // ✅ NEW

import CreateIssueScreen from "../screens/create_issue.screen";

import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import { useStateContext } from "../context/ContextProvider";
import { LegendToggle, Note } from "@mui/icons-material";
import axiosClient from "../axiosClient";
import GDPRPolicyLink from "./GDPRPolicyLink";
import Modal from "@mui/material/Modal";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Collapse from "@mui/material/Collapse";
import { useThemeContext } from "../context/ThemeContext";
import { Tooltip, Button } from "@mui/material";

import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import { useTheme } from "@mui/material/styles";

function DrawerApp() {
  const theme = useTheme();
  const { mode, toggleTheme } = useThemeContext();
  const drawerWidth = 260;
  const { user, _setUser, setToken, token } = useStateContext();

  const [mobileOpen, setMobileOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  const [selectedAppointmentId, setSelectedAppointmentId] = useState(null);
  const [showGDPRModal, setShowGDPRModal] = useState(false);
  const [isSubmittingAgreement, setIsSubmittingAgreement] = useState(false);

  const [submenuOpen, setSubmenuOpen] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const [appointmentMenuOpen, setAppointmentMenuOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const { view, setView } = useStateContext();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (["clients", "search_users", "new_user", "edit_delete_user", "staff"].includes(view)) {
      setUserMenuOpen(true);
    }
    if (
      ["appointments", "my_appointment", "create_appointment", "edit_delete_appointment", "appointment_list"].includes(
        view
      )
    ) {
      setAppointmentMenuOpen(true);
    }

    // ✅ Monitoring submenu auto-open when any of these views is active
    if (
      [
        "make_excel_file",
        "send_email_sms",
        "reports",
        "assigned_client_stats",
        "client_stats",
        "create_issue",
        "service_issues", // ✅ NEW
      ].includes(view)
    ) {
      setSubmenuOpen(true);
    }
  }, [view]);

  useEffect(() => {
    if (user?.user_role === "CLIENT" && !user.gdpr_accepted) {
      setShowGDPRModal(true);
    }
  }, [user]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };

  const handleSaveAppointment = () => {
    setSelectedAppointmentId(null);
    setView("appointments");
  };

  const handleDeleteAppointment = () => {
    setSelectedAppointmentId(null);
    setView("appointments");
  };

  const downloadGDPRreport = useCallback(async () => {
    try {
      const response = await axiosClient.get("api/gdpr-report", {
        responseType: "blob",
      });
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `report.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading the PDF", error);
    }
  }, []);

  const handleGDPRAgreement = async () => {
    setIsSubmittingAgreement(true);
    try {
      const ipRes = await fetch("https://api.ipify.org?format=json");
      const { ip } = await ipRes.json();
      await axiosClient.post(
        "/api/gdpr/accept/",
        { ip_address: ip, agreement_time: new Date().toISOString() },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            Authorization: `JWT-${token}`,
          },
        }
      );
      _setUser({ ...user, gdpr_accepted: true });
      setShowGDPRModal(false);
    } catch (err) {
      if (err.response && err.response.data) {
        alert(err.response.data[0] || "Failed to accept GDPR.");
      } else {
        console.error("GDPR agreement failed:", err);
      }
    } finally {
      setIsSubmittingAgreement(false);
    }
  };

  const handleUserMenuClick = (event) => setAnchorEl(event.currentTarget);
  const handleUserMenuClose = () => setAnchorEl(null);

  const handleProfileClick = () => {
    setView("user_profile");
    handleUserMenuClose();
  };

  const activeItemStyle = {
    bgcolor: "primary.main",
    color: `${theme.palette.mode === "light" ? "black" : "white"}`,
    "& .MuiListItemIcon-root": {
      color: `${theme.palette.mode === "light" ? "black" : "white"}`,
    },
  };

  const isActive = (viewName) => view === viewName;

  const primaryMenuItems = useMemo(
    () => [
      {
        name: t("Notes"),
        icon: <Note />,
        view: "notes",
        handleClick: () => setView("notes"),
        canSee: ["ADMIN"],
      },
    ],
    [t, setView]
  );

  const gdprMenuItems = useMemo(
    () => [
      {
        name: t("GDPR REPORT"),
        icon: <Note />,
        view: null,
        handleClick: () => downloadGDPRreport(),
        canSee: ["CLIENT"],
      },
      {
        name: t("GDPR POLICY"),
        icon: <Note />,
        view: "gdpr_policy",
        handleClick: () => setView("gdpr_policy"),
        canSee: ["ADMIN", "STAFF", "CLIENT"],
      },
    ],
    [t, setView, downloadGDPRreport]
  );

  const drawer = (
    <div>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: 2,
          marginBottom: 1,
        }}
      >
        <ListItemButton onClick={handleUserMenuClick} sx={{ display: "flex", alignItems: "center" }}>
          <AccountCircleIcon />
          <Typography variant="body2" align="center" sx={{ ml: 4, fontSize: "14px" }}>
            {`${user.first_name} ${user.last_name}`}
          </Typography>
        </ListItemButton>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleUserMenuClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          transformOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <MenuItem onClick={handleProfileClick}>
            <Typography variant="body2">{t("Profile")}</Typography>
          </MenuItem>
        </Menu>
      </Box>

      <Divider />

      {(user.user_role === "ADMIN" || user.user_role === "STAFF") && (
        <>
          <ListItemButton
            sx={{
              borderRadius: 2,
              mx: 0,
              my: 0.5,
              "&:hover": { bgcolor: "action.hover" },
              ...(["clients", "search_users", "new_user", "edit_delete_user", "staff"].includes(view) && {
                bgcolor: "action.selected",
              }),
            }}
            onClick={() => setUserMenuOpen(!userMenuOpen)}
          >
            <ListItemIcon>
              <PersonIcon />
            </ListItemIcon>
            <ListItemText primary={t("Users Management")} primaryTypographyProps={{ variant: "body2" }} />
            {userMenuOpen ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>

          <Collapse in={userMenuOpen} timeout={{ enter: 100, exit: 100 }} unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton
                sx={{ pl: 4, ...(isActive("clients") && activeItemStyle) }}
                onClick={() => setView("clients")}
                selected={isActive("clients")}
              >
                <ListItemIcon>
                  <PersonIcon />
                </ListItemIcon>
                <ListItemText primary={t("Users")} primaryTypographyProps={{ variant: "body2" }} />
              </ListItemButton>

              <ListItemButton
                sx={{ pl: 4, ...(isActive("search_users") && activeItemStyle) }}
                onClick={() => setView("search_users")}
                selected={isActive("search_users")}
              >
                <ListItemIcon>
                  <SearchIcon />
                </ListItemIcon>
                <ListItemText primary={t("Search Users")} primaryTypographyProps={{ variant: "body2" }} />
              </ListItemButton>

              <ListItemButton
                sx={{ pl: 4, ...(isActive("new_user") && activeItemStyle) }}
                onClick={() => setView("new_user")}
                selected={isActive("new_user")}
              >
                <ListItemIcon>
                  <PersonAddIcon />
                </ListItemIcon>
                <ListItemText primary={t("New User")} primaryTypographyProps={{ variant: "body2" }} />
              </ListItemButton>

              <ListItemButton
                sx={{ pl: 4, ...(isActive("edit_delete_user") && activeItemStyle) }}
                onClick={() => setView("edit_delete_user")}
                selected={isActive("edit_delete_user")}
              >
                <ListItemIcon>
                  <PersonIcon />
                </ListItemIcon>
                <ListItemText primary={t("Edit/Delete User")} primaryTypographyProps={{ variant: "body2" }} />
              </ListItemButton>

              <ListItemButton
                sx={{ pl: 4, ...(isActive("staff") && activeItemStyle) }}
                onClick={() => setView("staff")}
                selected={isActive("staff")}
              >
                <ListItemIcon>
                  <TransferWithinAStationIcon />
                </ListItemIcon>
                <ListItemText primary={t("Clients to staff")} primaryTypographyProps={{ variant: "body2" }} />
              </ListItemButton>
            </List>
          </Collapse>
        </>
      )}

      <ListItemButton
        sx={{
          borderRadius: 2,
          mx: 0,
          my: 0.5,
          "&:hover": { bgcolor: "action.hover" },
          ...(
            ["appointments", "my_appointment", "create_appointment", "edit_delete_appointment", "appointment_list"].includes(view) && {
              bgcolor: "action.selected",
            }
          ),
        }}
        onClick={() => setAppointmentMenuOpen(!appointmentMenuOpen)}
      >
        <ListItemIcon>
          <CalendarViewMonthIcon />
        </ListItemIcon>
        <ListItemText primary={t("Appointments")} primaryTypographyProps={{ variant: "body2" }} />
        {appointmentMenuOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>

      <Collapse in={appointmentMenuOpen} timeout={{ enter: 100, exit: 100 }} unmountOnExit>
        <List component="div" disablePadding>
          <ListItemButton
            sx={{ pl: 4, ...(isActive("appointments") && activeItemStyle) }}
            onClick={() => setView("appointments")}
            selected={isActive("appointments")}
          >
            <ListItemIcon>
              <CalendarViewMonthIcon />
            </ListItemIcon>
            <ListItemText primary={t("View Appointments")} primaryTypographyProps={{ variant: "body2" }} />
          </ListItemButton>

          <ListItemButton
            sx={{ pl: 4, ...(isActive("appointment_list") && activeItemStyle) }}
            onClick={() => setView("appointment_list")}
            selected={isActive("appointment_list")}
          >
            <ListItemIcon>
              <ListIcon />
            </ListItemIcon>
            <ListItemText primary={t("Appointment List")} primaryTypographyProps={{ variant: "body2" }} />
          </ListItemButton>

          {user.user_role === "CLIENT" && (
            <ListItemButton
              sx={{ pl: 4, ...(isActive("my_appointment") && activeItemStyle) }}
              onClick={() => setView("my_appointment")}
              selected={isActive("my_appointment")}
            >
              <ListItemIcon>
                <CalendarViewMonthIcon />
              </ListItemIcon>
              <ListItemText primary={t("MY Appointments")} primaryTypographyProps={{ variant: "body2" }} />
            </ListItemButton>
          )}

          {(user.user_role === "ADMIN" || user.user_role === "STAFF") && (
            <>
              <ListItemButton
                sx={{ pl: 4, ...(isActive("create_appointment") && activeItemStyle) }}
                onClick={() => setView("create_appointment")}
                selected={isActive("create_appointment")}
              >
                <ListItemIcon>
                  <EditCalendarIcon />
                </ListItemIcon>
                <ListItemText primary={t("Create appointment")} primaryTypographyProps={{ variant: "body2" }} />
              </ListItemButton>

              <ListItemButton
                sx={{ pl: 4, ...(isActive("edit_delete_appointment") && activeItemStyle) }}
                onClick={() => setView("edit_delete_appointment")}
                selected={isActive("edit_delete_appointment")}
              >
                <ListItemIcon>
                  <EditCalendarIcon />
                </ListItemIcon>
                <ListItemText primary={t("Edit/Delete appointment")} primaryTypographyProps={{ variant: "body2" }} />
              </ListItemButton>
            </>
          )}
        </List>
      </Collapse>

      <List>
        {primaryMenuItems.map((object) => {
          if (object.canSee.includes(user.user_role)) {
            return (
              <ListItem key={object.name} disablePadding>
                <ListItemButton
                  onClick={object.handleClick}
                  sx={{ ...(isActive(object.view) && activeItemStyle), borderRadius: 1 }}
                  selected={isActive(object.view)}
                >
                  <ListItemIcon>{object.icon}</ListItemIcon>
                  <ListItemText primary={object.name} primaryTypographyProps={{ variant: "body2" }} />
                </ListItemButton>
              </ListItem>
            );
          }
          return null;
        })}

        {(user.user_role === "ADMIN" || user.user_role === "STAFF") && (
          <>
            <ListItemButton
              sx={{
                borderRadius: 2,
                mx: 0,
                my: 0.5,
                "&:hover": { bgcolor: "action.hover" },
                ...(
                  [
                    "make_excel_file",
                    "send_email_sms",
                    "reports",
                    "assigned_client_stats",
                    "client_stats",
                    "create_issue",
                    "service_issues", // ✅ NEW
                  ].includes(view) && { bgcolor: "action.selected" }
                ),
              }}
              onClick={() => setSubmenuOpen(!submenuOpen)}
            >
              <ListItemIcon>
                <LegendToggle />
              </ListItemIcon>
              <ListItemText primary={t("Monitoring")} primaryTypographyProps={{ variant: "body2" }} />
              {submenuOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>

            <Collapse in={submenuOpen} timeout={{ enter: 100, exit: 100 }} unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton
                  sx={{ pl: 4, ...(isActive("make_excel_file") && activeItemStyle) }}
                  onClick={() => setView("make_excel_file")}
                  selected={isActive("make_excel_file")}
                >
                  <ListItemText inset primary={t("Make excel file")} primaryTypographyProps={{ variant: "body2" }} />
                </ListItemButton>

                <ListItemButton
                  sx={{ pl: 4, ...(isActive("send_email_sms") && activeItemStyle) }}
                  onClick={() => setView("send_email_sms")}
                  selected={isActive("send_email_sms")}
                >
                  <ListItemText
                    inset
                    primary={t("Send Email/SMS excel file")}
                    primaryTypographyProps={{ variant: "body2" }}
                  />
                </ListItemButton>

                <ListItemButton
                  sx={{ pl: 4, ...(isActive("reports") && activeItemStyle) }}
                  onClick={() => setView("reports")}
                  selected={isActive("reports")}
                >
                  <ListItemText inset primary={t("Reports")} primaryTypographyProps={{ variant: "body2" }} />
                </ListItemButton>

                <ListItemButton
                  sx={{ pl: 4, ...(isActive("assigned_client_stats") && activeItemStyle) }}
                  onClick={() => setView("assigned_client_stats")}
                  selected={isActive("assigned_client_stats")}
                >
                  <ListItemText
                    inset
                    primary={t("Assigned Client Stats")}
                    primaryTypographyProps={{ variant: "body2" }}
                  />
                </ListItemButton>

                <ListItemButton
                  sx={{ pl: 4, ...(isActive("client_stats") && activeItemStyle) }}
                  onClick={() => setView("client_stats")}
                  selected={isActive("client_stats")}
                >
                  <ListItemText inset primary={t("Client Stats")} primaryTypographyProps={{ variant: "body2" }} />
                </ListItemButton>

                {/* ✅ Create Issue */}
                <ListItemButton
                  sx={{ pl: 4, ...(isActive("create_issue") && activeItemStyle) }}
                  onClick={() => setView("create_issue")}
                  selected={isActive("create_issue")}
                >
                  <ListItemIcon>
                    <BugReportIcon />
                  </ListItemIcon>
                  <ListItemText primary={t("Create Issue")} primaryTypographyProps={{ variant: "body2" }} />
                </ListItemButton>

                {/* ✅ NEW: Service Issues */}
                <ListItemButton
                  sx={{ pl: 4, ...(isActive("service_issues") && activeItemStyle) }}
                  onClick={() => setView("service_issues")}
                  selected={isActive("service_issues")}
                >
                  <ListItemIcon>
                    <BugReportIcon />
                  </ListItemIcon>
                  <ListItemText primary={t("Service Issues")} primaryTypographyProps={{ variant: "body2" }} />
                </ListItemButton>
              </List>
            </Collapse>
          </>
        )}
      </List>

      <List>
        {gdprMenuItems.map((object) => {
          if (object.canSee.includes(user.user_role)) {
            return (
              <ListItem key={object.name} disablePadding>
                <ListItemButton
                  onClick={object.handleClick}
                  sx={{ ...(object.view && isActive(object.view) && activeItemStyle), borderRadius: 1 }}
                  selected={object.view && isActive(object.view)}
                >
                  <ListItemIcon>{object.icon}</ListItemIcon>
                  <ListItemText primary={object.name} primaryTypographyProps={{ variant: "body2" }} />
                </ListItemButton>
              </ListItem>
            );
          }
          return null;
        })}
      </List>

      <Divider />

      <List>
        {[
          {
            name: `${t("Reset password")}`,
            icon: <PasswordIcon />,
            view: "reset_password",
            handleClick: () => setView("reset_password"),
          },
          {
            name: `${t("Logout")}`,
            icon: <LogoutIcon />,
            view: null,
            handleClick: () => {
              setToken(null);
              _setUser({});
              window.location.reload();
            },
          },
        ].map((object) => (
          <ListItem key={object.name} disablePadding>
            <ListItemButton
              onClick={object.handleClick}
              sx={{ ...(object.view && isActive(object.view) && activeItemStyle), borderRadius: 1 }}
              selected={object.view && isActive(object.view)}
            >
              <ListItemIcon>{object.icon}</ListItemIcon>
              <ListItemText primary={object.name} primaryTypographyProps={{ variant: "body2" }} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </div>
  );

  return (
    <div className="App">
      {showGDPRModal && (
        <Modal open={showGDPRModal} onClose={() => {}} disableEscapeKeyDown>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "90%",
              maxWidth: 600,
              maxHeight: "90vh",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
              overflowY: "auto",
            }}
          >
            <Typography variant="h6" sx={{ mb: 2 }}>
              {t("GDPR Title")}
            </Typography>

            <Typography variant="body2" sx={{ mb: 2 }}>
              {t("GDPR Section 1 Intro P1")}
            </Typography>

            <Box sx={{ mb: 3 }}>
              <GDPRPolicyLink />
            </Box>

            <Typography variant="body2" sx={{ mb: 3 }}>
              {t("Agreed to GDPR Policy?")}
            </Typography>

            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
              <Button variant="contained" color="primary" onClick={handleGDPRAgreement} disabled={isSubmittingAgreement}>
                {t("Yes")}
              </Button>
            </Box>
          </Box>
        </Modal>
      )}

      <Box sx={{ display: "flex" }}>
        <CssBaseline />

        <AppBar
          position="fixed"
          sx={{
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            ml: { sm: `${drawerWidth}px` },
          }}
        >
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2, display: { sm: "none" } }}
            >
              <MenuIcon />
            </IconButton>

            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "90%" }}>
              <Typography
                variant="h6"
                noWrap
                component="div"
                sx={{
                  flexGrow: 1,
                  mr: 2,
                  fontFamily: "TempusFont, Arial, sans-serif",
                  fontSize: "32px",
                  fontWeight: 400,
                  letterSpacing: "1px",
                }}
              >
                Tempus Management System
              </Typography>

              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <select
                  onChange={(e) => changeLanguage(e.target.value)}
                  value={Cookies.get("i18next")}
                  style={{ padding: "5px", borderRadius: "4px" }}
                >
                  <option value="en">English</option>
                  <option value="el">Greek</option>
                </select>

                <Tooltip title={`Switch to ${mode === "light" ? "Dark" : "Light"} Mode`}>
                  <IconButton onClick={toggleTheme} color="inherit">
                    {mode === "light" ? <Brightness4Icon /> : <Brightness7Icon />}
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>
          </Toolbar>
        </AppBar>

        <Box component="nav" sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }} aria-label="mailbox folders">
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onTransitionEnd={handleDrawerTransitionEnd}
            onClose={handleDrawerClose}
            ModalProps={{ keepMounted: true }}
            sx={{
              display: { xs: "block", sm: "none" },
              "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth },
            }}
          >
            {drawer}
          </Drawer>

          <Drawer
            variant="permanent"
            sx={{
              display: { xs: "none", sm: "block" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
                bgcolor: "background.default",
                borderRight: "1px solid #e0e0e0",
              },
            }}
            open
          >
            {drawer}
          </Drawer>
        </Box>

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            overflowX: "auto",
          }}
        >
          <Toolbar />

          {view === "appointments" ? (
            <FullCalendarApp />
          ) : view === "user_profile" ? (
            <Profile />
          ) : view === "clients" ? (
            <Clients />
          ) : view === "new_user" ? (
            <UserForm />
          ) : view === "staff" ? (
            <Staff />
          ) : view === "create_appointment" ? (
            <AppointmentForm />
          ) : view === "edit_delete_appointment" ? (
            <EditDeleteAppointment
              appointmentId={selectedAppointmentId}
              onSave={handleSaveAppointment}
              onDelete={handleDeleteAppointment}
            />
          ) : view === "reports" ? (
            <Reports />
          ) : view === "reset_password" ? (
            <ResetPasswordForm />
          ) : view === "make_excel_file" ? (
            <MakeExcelFile />
          ) : view === "send_email_sms" ? (
            <SendEmailSMS />
          ) : view === "assigned_client_stats" ? (
            <AssignedClientStats />
          ) : view === "client_stats" ? (
            <ClientStats />
          ) : view === "my_appointment" ? (
            <AppointmentList />
          ) : view === "edit_delete_user" ? (
            <EditDeleteUsers />
          ) : view === "notes" ? (
            <Notes />
          ) : view === "search_users" ? (
            <SearchUsers />
          ) : view === "gdpr_policy" ? (
            <GDPRPOLICY />
          ) : view === "appointment_list" ? (
            <AppointmentListView />
          ) : view === "create_issue" ? (
            <CreateIssueScreen />
          ) : view === "service_issues" ? (
            <ServiceIssues />
          ) : (
            <Typography variant="h4">Oops something went wrong!</Typography>
          )}
        </Box>
      </Box>
    </div>
  );
}

export default DrawerApp;